export const PlusIcon = ({ w = "15", h = "15" }) => (
  <svg
    width={w}
    height={h}
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.66667 15V8.33333H0V6.66667H6.66667V0H8.33333V6.66667H15V8.33333H8.33333V15H6.66667Z"
      fill="white"
    />
  </svg>
);

export const CrossIcon = ({ w = "14", h = "14" }) => (
  <svg
    className="cursor-pointer"
    role="button"
    aria-label="Close"
    width={w}
    height={h}
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.8925 0.3025C12.5025 -0.0874998 11.8725 -0.0874998 11.4825 0.3025L6.5925 5.1825L1.7025 0.2925C1.3125 -0.0975 0.6825 -0.0975 0.2925 0.2925C-0.0975 0.6825 -0.0975 1.3125 0.2925 1.7025L5.1825 6.5925L0.2925 11.4825C-0.0975 11.8725 -0.0975 12.5025 0.2925 12.8925C0.6825 13.2825 1.3125 13.2825 1.7025 12.8925L6.5925 8.0025L11.4825 12.8925C11.8725 13.2825 12.5025 13.2825 12.8925 12.8925C13.2825 12.5025 13.2825 11.8725 12.8925 11.4825L8.0025 6.5925L12.8925 1.7025C13.2725 1.3225 13.2725 0.6825 12.8925 0.3025Z"
      fill="#232323"
    />
  </svg>
);
export const StorageIcon = ({ w = "18", h = "13" }) => (
  <svg
    width={w}
    height={h}
    viewBox="0 0 18 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.35417 12.6667C3.15347 12.6667 2.1276 12.251 1.27656 11.4198C0.425521 10.5885 0 9.57257 0 8.37187C0 7.34271 0.310069 6.42569 0.930208 5.62083C1.55035 4.81597 2.36181 4.30139 3.36458 4.07708C3.69444 2.86319 4.35417 1.88021 5.34375 1.12812C6.33333 0.376042 7.45486 0 8.70833 0C10.2521 0 11.5616 0.537674 12.637 1.61302C13.7123 2.68837 14.25 3.99792 14.25 5.54167C15.1604 5.64722 15.9158 6.03976 16.5161 6.71927C17.1165 7.39878 17.4167 8.19375 17.4167 9.10417C17.4167 10.0937 17.0703 10.9349 16.3776 11.6276C15.6849 12.3203 14.8437 12.6667 13.8542 12.6667H4.35417ZM4.35417 11.0833H13.8542C14.4083 11.0833 14.8767 10.892 15.2594 10.5094C15.642 10.1267 15.8333 9.65833 15.8333 9.10417C15.8333 8.55 15.642 8.0816 15.2594 7.69896C14.8767 7.31632 14.4083 7.125 13.8542 7.125H12.6667V5.54167C12.6667 4.44653 12.2807 3.51302 11.5089 2.74115C10.737 1.96927 9.80347 1.58333 8.70833 1.58333C7.61319 1.58333 6.67969 1.96927 5.90781 2.74115C5.13594 3.51302 4.75 4.44653 4.75 5.54167H4.35417C3.58889 5.54167 2.93576 5.81215 2.39479 6.35313C1.85382 6.8941 1.58333 7.54722 1.58333 8.3125C1.58333 9.07778 1.85382 9.7309 2.39479 10.2719C2.93576 10.8128 3.58889 11.0833 4.35417 11.0833Z"
      fill="#555555"
    />
  </svg>
);

export const FilterIcon = ({ w = "18", h = "18" }) => (
  <svg
    width={w}
    height={h}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 18V12H10V14H18V16H10V18H8ZM0 16V14H6V16H0ZM4 12V10H0V8H4V6H6V12H4ZM8 10V8H18V10H8ZM12 6V0H14V2H18V4H14V6H12ZM0 4V2H10V4H0Z"
      fill="#1F1F1F"
    />
  </svg>
);
export const ListActiveIcon = ({ w = "20", h = "20" }) => (
  <svg
    width={w}
    height={h}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="20" height="20" rx="4" fill="#0068FF" />
    <mask
      id="mask0_14823_281390"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="2"
      y="2"
      width="16"
      height="16"
    >
      <rect x="2" y="2" width="16" height="16" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_14823_281390)">
      <path
        d="M8.70777 14.4996C8.5661 14.4996 8.44733 14.4517 8.35144 14.3558C8.25566 14.2599 8.20777 14.1411 8.20777 13.9995C8.20777 13.8577 8.25566 13.739 8.35144 13.6433C8.44733 13.5475 8.5661 13.4996 8.70777 13.4996H15.1693C15.3109 13.4996 15.4297 13.5476 15.5254 13.6435C15.6213 13.7393 15.6693 13.8581 15.6693 13.9998C15.6693 14.1416 15.6213 14.2603 15.5254 14.356C15.4297 14.4517 15.3109 14.4996 15.1693 14.4996H8.70777ZM8.70777 10.4996C8.5661 10.4996 8.44733 10.4517 8.35144 10.3558C8.25566 10.2599 8.20777 10.1411 8.20777 9.99946C8.20777 9.85768 8.25566 9.73896 8.35144 9.64329C8.44733 9.54751 8.5661 9.49962 8.70777 9.49962H15.1693C15.3109 9.49962 15.4297 9.54757 15.5254 9.64346C15.6213 9.73935 15.6693 9.85812 15.6693 9.99979C15.6693 10.1416 15.6213 10.2603 15.5254 10.356C15.4297 10.4517 15.3109 10.4996 15.1693 10.4996H8.70777ZM8.70777 6.49962C8.5661 6.49962 8.44733 6.45168 8.35144 6.35579C8.25566 6.2599 8.20777 6.14112 8.20777 5.99946C8.20777 5.85768 8.25566 5.73896 8.35144 5.64329C8.44733 5.54751 8.5661 5.49962 8.70777 5.49962H15.1693C15.3109 5.49962 15.4297 5.54757 15.5254 5.64346C15.6213 5.73935 15.6693 5.85812 15.6693 5.99979C15.6693 6.14157 15.6213 6.26029 15.5254 6.35596C15.4297 6.45174 15.3109 6.49962 15.1693 6.49962H8.70777ZM5.44494 15.1086C5.13994 15.1086 4.87888 15 4.66177 14.7828C4.44455 14.5657 4.33594 14.3046 4.33594 13.9996C4.33594 13.6946 4.44455 13.4336 4.66177 13.2165C4.87888 12.9992 5.13994 12.8906 5.44494 12.8906C5.74994 12.8906 6.01099 12.9992 6.2281 13.2165C6.44533 13.4336 6.55394 13.6946 6.55394 13.9996C6.55394 14.3046 6.44533 14.5657 6.2281 14.7828C6.01099 15 5.74994 15.1086 5.44494 15.1086ZM5.44494 11.1086C5.13994 11.1086 4.87888 11 4.66177 10.7828C4.44455 10.5657 4.33594 10.3046 4.33594 9.99962C4.33594 9.69462 4.44455 9.43357 4.66177 9.21646C4.87888 8.99924 5.13994 8.89062 5.44494 8.89062C5.74994 8.89062 6.01099 8.99924 6.2281 9.21646C6.44533 9.43357 6.55394 9.69462 6.55394 9.99962C6.55394 10.3046 6.44533 10.5657 6.2281 10.7828C6.01099 11 5.74994 11.1086 5.44494 11.1086ZM5.44494 7.10862C5.13994 7.10862 4.87888 7.00001 4.66177 6.78279C4.44455 6.56568 4.33594 6.30462 4.33594 5.99962C4.33594 5.69462 4.44455 5.43357 4.66177 5.21646C4.87888 4.99924 5.13994 4.89062 5.44494 4.89062C5.74994 4.89062 6.01099 4.99924 6.2281 5.21646C6.44533 5.43357 6.55394 5.69462 6.55394 5.99962C6.55394 6.30462 6.44533 6.56568 6.2281 6.78279C6.01099 7.00001 5.74994 7.10862 5.44494 7.10862Z"
        fill="white"
      />
    </g>
  </svg>
);
export const MobSelectAllIcon = ({ w = "18", h = "18" }) => (
  <svg
    width={w}
    height={h}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1 2C0.716667 2 0.479167 1.90417 0.2875 1.7125C0.0958333 1.52083 0 1.28333 0 1C0 0.716667 0.0958333 0.479167 0.2875 0.2875C0.479167 0.0958333 0.716667 0 1 0C1.28333 0 1.52083 0.0958333 1.7125 0.2875C1.90417 0.479167 2 0.716667 2 1C2 1.28333 1.90417 1.52083 1.7125 1.7125C1.52083 1.90417 1.28333 2 1 2ZM5 2C4.71667 2 4.47917 1.90417 4.2875 1.7125C4.09583 1.52083 4 1.28333 4 1C4 0.716667 4.09583 0.479167 4.2875 0.2875C4.47917 0.0958333 4.71667 0 5 0C5.28333 0 5.52083 0.0958333 5.7125 0.2875C5.90417 0.479167 6 0.716667 6 1C6 1.28333 5.90417 1.52083 5.7125 1.7125C5.52083 1.90417 5.28333 2 5 2ZM9 2C8.71667 2 8.47917 1.90417 8.2875 1.7125C8.09583 1.52083 8 1.28333 8 1C8 0.716667 8.09583 0.479167 8.2875 0.2875C8.47917 0.0958333 8.71667 0 9 0C9.28333 0 9.52083 0.0958333 9.7125 0.2875C9.90417 0.479167 10 0.716667 10 1C10 1.28333 9.90417 1.52083 9.7125 1.7125C9.52083 1.90417 9.28333 2 9 2ZM13 2C12.7167 2 12.4792 1.90417 12.2875 1.7125C12.0958 1.52083 12 1.28333 12 1C12 0.716667 12.0958 0.479167 12.2875 0.2875C12.4792 0.0958333 12.7167 0 13 0C13.2833 0 13.5208 0.0958333 13.7125 0.2875C13.9042 0.479167 14 0.716667 14 1C14 1.28333 13.9042 1.52083 13.7125 1.7125C13.5208 1.90417 13.2833 2 13 2ZM17 2C16.7167 2 16.4792 1.90417 16.2875 1.7125C16.0958 1.52083 16 1.28333 16 1C16 0.716667 16.0958 0.479167 16.2875 0.2875C16.4792 0.0958333 16.7167 0 17 0C17.2833 0 17.5208 0.0958333 17.7125 0.2875C17.9042 0.479167 18 0.716667 18 1C18 1.28333 17.9042 1.52083 17.7125 1.7125C17.5208 1.90417 17.2833 2 17 2ZM1 6C0.716667 6 0.479167 5.90417 0.2875 5.7125C0.0958333 5.52083 0 5.28333 0 5C0 4.71667 0.0958333 4.47917 0.2875 4.2875C0.479167 4.09583 0.716667 4 1 4C1.28333 4 1.52083 4.09583 1.7125 4.2875C1.90417 4.47917 2 4.71667 2 5C2 5.28333 1.90417 5.52083 1.7125 5.7125C1.52083 5.90417 1.28333 6 1 6ZM17 6C16.7167 6 16.4792 5.90417 16.2875 5.7125C16.0958 5.52083 16 5.28333 16 5C16 4.71667 16.0958 4.47917 16.2875 4.2875C16.4792 4.09583 16.7167 4 17 4C17.2833 4 17.5208 4.09583 17.7125 4.2875C17.9042 4.47917 18 4.71667 18 5C18 5.28333 17.9042 5.52083 17.7125 5.7125C17.5208 5.90417 17.2833 6 17 6ZM1 10C0.716667 10 0.479167 9.90417 0.2875 9.7125C0.0958333 9.52083 0 9.28333 0 9C0 8.71667 0.0958333 8.47917 0.2875 8.2875C0.479167 8.09583 0.716667 8 1 8C1.28333 8 1.52083 8.09583 1.7125 8.2875C1.90417 8.47917 2 8.71667 2 9C2 9.28333 1.90417 9.52083 1.7125 9.7125C1.52083 9.90417 1.28333 10 1 10ZM17 10C16.7167 10 16.4792 9.90417 16.2875 9.7125C16.0958 9.52083 16 9.28333 16 9C16 8.71667 16.0958 8.47917 16.2875 8.2875C16.4792 8.09583 16.7167 8 17 8C17.2833 8 17.5208 8.09583 17.7125 8.2875C17.9042 8.47917 18 8.71667 18 9C18 9.28333 17.9042 9.52083 17.7125 9.7125C17.5208 9.90417 17.2833 10 17 10ZM1 14C0.716667 14 0.479167 13.9042 0.2875 13.7125C0.0958333 13.5208 0 13.2833 0 13C0 12.7167 0.0958333 12.4792 0.2875 12.2875C0.479167 12.0958 0.716667 12 1 12C1.28333 12 1.52083 12.0958 1.7125 12.2875C1.90417 12.4792 2 12.7167 2 13C2 13.2833 1.90417 13.5208 1.7125 13.7125C1.52083 13.9042 1.28333 14 1 14ZM17 14C16.7167 14 16.4792 13.9042 16.2875 13.7125C16.0958 13.5208 16 13.2833 16 13C16 12.7167 16.0958 12.4792 16.2875 12.2875C16.4792 12.0958 16.7167 12 17 12C17.2833 12 17.5208 12.0958 17.7125 12.2875C17.9042 12.4792 18 12.7167 18 13C18 13.2833 17.9042 13.5208 17.7125 13.7125C17.5208 13.9042 17.2833 14 17 14ZM1 18C0.716667 18 0.479167 17.9042 0.2875 17.7125C0.0958333 17.5208 0 17.2833 0 17C0 16.7167 0.0958333 16.4792 0.2875 16.2875C0.479167 16.0958 0.716667 16 1 16C1.28333 16 1.52083 16.0958 1.7125 16.2875C1.90417 16.4792 2 16.7167 2 17C2 17.2833 1.90417 17.5208 1.7125 17.7125C1.52083 17.9042 1.28333 18 1 18ZM5 18C4.71667 18 4.47917 17.9042 4.2875 17.7125C4.09583 17.5208 4 17.2833 4 17C4 16.7167 4.09583 16.4792 4.2875 16.2875C4.47917 16.0958 4.71667 16 5 16C5.28333 16 5.52083 16.0958 5.7125 16.2875C5.90417 16.4792 6 16.7167 6 17C6 17.2833 5.90417 17.5208 5.7125 17.7125C5.52083 17.9042 5.28333 18 5 18ZM9 18C8.71667 18 8.47917 17.9042 8.2875 17.7125C8.09583 17.5208 8 17.2833 8 17C8 16.7167 8.09583 16.4792 8.2875 16.2875C8.47917 16.0958 8.71667 16 9 16C9.28333 16 9.52083 16.0958 9.7125 16.2875C9.90417 16.4792 10 16.7167 10 17C10 17.2833 9.90417 17.5208 9.7125 17.7125C9.52083 17.9042 9.28333 18 9 18ZM13 18C12.7167 18 12.4792 17.9042 12.2875 17.7125C12.0958 17.5208 12 17.2833 12 17C12 16.7167 12.0958 16.4792 12.2875 16.2875C12.4792 16.0958 12.7167 16 13 16C13.2833 16 13.5208 16.0958 13.7125 16.2875C13.9042 16.4792 14 16.7167 14 17C14 17.2833 13.9042 17.5208 13.7125 17.7125C13.5208 17.9042 13.2833 18 13 18ZM17 18C16.7167 18 16.4792 17.9042 16.2875 17.7125C16.0958 17.5208 16 17.2833 16 17C16 16.7167 16.0958 16.4792 16.2875 16.2875C16.4792 16.0958 16.7167 16 17 16C17.2833 16 17.5208 16.0958 17.7125 16.2875C17.9042 16.4792 18 16.7167 18 17C18 17.2833 17.9042 17.5208 17.7125 17.7125C17.5208 17.9042 17.2833 18 17 18ZM6 14C5.45 14 4.97917 13.8042 4.5875 13.4125C4.19583 13.0208 4 12.55 4 12V6C4 5.45 4.19583 4.97917 4.5875 4.5875C4.97917 4.19583 5.45 4 6 4H12C12.55 4 13.0208 4.19583 13.4125 4.5875C13.8042 4.97917 14 5.45 14 6V12C14 12.55 13.8042 13.0208 13.4125 13.4125C13.0208 13.8042 12.55 14 12 14H6ZM6 12H12V6H6V12Z"
      fill="#333333"
    />
  </svg>
);
export const MobActiveSelectAllIcon = ({ w = "18", h = "18" }) => (
  <svg
    width={w}
    height={h}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1 2C0.716667 2 0.479167 1.90417 0.2875 1.7125C0.0958333 1.52083 0 1.28333 0 1C0 0.716667 0.0958333 0.479167 0.2875 0.2875C0.479167 0.0958333 0.716667 0 1 0C1.28333 0 1.52083 0.0958333 1.7125 0.2875C1.90417 0.479167 2 0.716667 2 1C2 1.28333 1.90417 1.52083 1.7125 1.7125C1.52083 1.90417 1.28333 2 1 2ZM5 2C4.71667 2 4.47917 1.90417 4.2875 1.7125C4.09583 1.52083 4 1.28333 4 1C4 0.716667 4.09583 0.479167 4.2875 0.2875C4.47917 0.0958333 4.71667 0 5 0C5.28333 0 5.52083 0.0958333 5.7125 0.2875C5.90417 0.479167 6 0.716667 6 1C6 1.28333 5.90417 1.52083 5.7125 1.7125C5.52083 1.90417 5.28333 2 5 2ZM9 2C8.71667 2 8.47917 1.90417 8.2875 1.7125C8.09583 1.52083 8 1.28333 8 1C8 0.716667 8.09583 0.479167 8.2875 0.2875C8.47917 0.0958333 8.71667 0 9 0C9.28333 0 9.52083 0.0958333 9.7125 0.2875C9.90417 0.479167 10 0.716667 10 1C10 1.28333 9.90417 1.52083 9.7125 1.7125C9.52083 1.90417 9.28333 2 9 2ZM13 2C12.7167 2 12.4792 1.90417 12.2875 1.7125C12.0958 1.52083 12 1.28333 12 1C12 0.716667 12.0958 0.479167 12.2875 0.2875C12.4792 0.0958333 12.7167 0 13 0C13.2833 0 13.5208 0.0958333 13.7125 0.2875C13.9042 0.479167 14 0.716667 14 1C14 1.28333 13.9042 1.52083 13.7125 1.7125C13.5208 1.90417 13.2833 2 13 2ZM17 2C16.7167 2 16.4792 1.90417 16.2875 1.7125C16.0958 1.52083 16 1.28333 16 1C16 0.716667 16.0958 0.479167 16.2875 0.2875C16.4792 0.0958333 16.7167 0 17 0C17.2833 0 17.5208 0.0958333 17.7125 0.2875C17.9042 0.479167 18 0.716667 18 1C18 1.28333 17.9042 1.52083 17.7125 1.7125C17.5208 1.90417 17.2833 2 17 2ZM1 6C0.716667 6 0.479167 5.90417 0.2875 5.7125C0.0958333 5.52083 0 5.28333 0 5C0 4.71667 0.0958333 4.47917 0.2875 4.2875C0.479167 4.09583 0.716667 4 1 4C1.28333 4 1.52083 4.09583 1.7125 4.2875C1.90417 4.47917 2 4.71667 2 5C2 5.28333 1.90417 5.52083 1.7125 5.7125C1.52083 5.90417 1.28333 6 1 6ZM17 6C16.7167 6 16.4792 5.90417 16.2875 5.7125C16.0958 5.52083 16 5.28333 16 5C16 4.71667 16.0958 4.47917 16.2875 4.2875C16.4792 4.09583 16.7167 4 17 4C17.2833 4 17.5208 4.09583 17.7125 4.2875C17.9042 4.47917 18 4.71667 18 5C18 5.28333 17.9042 5.52083 17.7125 5.7125C17.5208 5.90417 17.2833 6 17 6ZM1 10C0.716667 10 0.479167 9.90417 0.2875 9.7125C0.0958333 9.52083 0 9.28333 0 9C0 8.71667 0.0958333 8.47917 0.2875 8.2875C0.479167 8.09583 0.716667 8 1 8C1.28333 8 1.52083 8.09583 1.7125 8.2875C1.90417 8.47917 2 8.71667 2 9C2 9.28333 1.90417 9.52083 1.7125 9.7125C1.52083 9.90417 1.28333 10 1 10ZM17 10C16.7167 10 16.4792 9.90417 16.2875 9.7125C16.0958 9.52083 16 9.28333 16 9C16 8.71667 16.0958 8.47917 16.2875 8.2875C16.4792 8.09583 16.7167 8 17 8C17.2833 8 17.5208 8.09583 17.7125 8.2875C17.9042 8.47917 18 8.71667 18 9C18 9.28333 17.9042 9.52083 17.7125 9.7125C17.5208 9.90417 17.2833 10 17 10ZM1 14C0.716667 14 0.479167 13.9042 0.2875 13.7125C0.0958333 13.5208 0 13.2833 0 13C0 12.7167 0.0958333 12.4792 0.2875 12.2875C0.479167 12.0958 0.716667 12 1 12C1.28333 12 1.52083 12.0958 1.7125 12.2875C1.90417 12.4792 2 12.7167 2 13C2 13.2833 1.90417 13.5208 1.7125 13.7125C1.52083 13.9042 1.28333 14 1 14ZM17 14C16.7167 14 16.4792 13.9042 16.2875 13.7125C16.0958 13.5208 16 13.2833 16 13C16 12.7167 16.0958 12.4792 16.2875 12.2875C16.4792 12.0958 16.7167 12 17 12C17.2833 12 17.5208 12.0958 17.7125 12.2875C17.9042 12.4792 18 12.7167 18 13C18 13.2833 17.9042 13.5208 17.7125 13.7125C17.5208 13.9042 17.2833 14 17 14ZM1 18C0.716667 18 0.479167 17.9042 0.2875 17.7125C0.0958333 17.5208 0 17.2833 0 17C0 16.7167 0.0958333 16.4792 0.2875 16.2875C0.479167 16.0958 0.716667 16 1 16C1.28333 16 1.52083 16.0958 1.7125 16.2875C1.90417 16.4792 2 16.7167 2 17C2 17.2833 1.90417 17.5208 1.7125 17.7125C1.52083 17.9042 1.28333 18 1 18ZM5 18C4.71667 18 4.47917 17.9042 4.2875 17.7125C4.09583 17.5208 4 17.2833 4 17C4 16.7167 4.09583 16.4792 4.2875 16.2875C4.47917 16.0958 4.71667 16 5 16C5.28333 16 5.52083 16.0958 5.7125 16.2875C5.90417 16.4792 6 16.7167 6 17C6 17.2833 5.90417 17.5208 5.7125 17.7125C5.52083 17.9042 5.28333 18 5 18ZM9 18C8.71667 18 8.47917 17.9042 8.2875 17.7125C8.09583 17.5208 8 17.2833 8 17C8 16.7167 8.09583 16.4792 8.2875 16.2875C8.47917 16.0958 8.71667 16 9 16C9.28333 16 9.52083 16.0958 9.7125 16.2875C9.90417 16.4792 10 16.7167 10 17C10 17.2833 9.90417 17.5208 9.7125 17.7125C9.52083 17.9042 9.28333 18 9 18ZM13 18C12.7167 18 12.4792 17.9042 12.2875 17.7125C12.0958 17.5208 12 17.2833 12 17C12 16.7167 12.0958 16.4792 12.2875 16.2875C12.4792 16.0958 12.7167 16 13 16C13.2833 16 13.5208 16.0958 13.7125 16.2875C13.9042 16.4792 14 16.7167 14 17C14 17.2833 13.9042 17.5208 13.7125 17.7125C13.5208 17.9042 13.2833 18 13 18ZM17 18C16.7167 18 16.4792 17.9042 16.2875 17.7125C16.0958 17.5208 16 17.2833 16 17C16 16.7167 16.0958 16.4792 16.2875 16.2875C16.4792 16.0958 16.7167 16 17 16C17.2833 16 17.5208 16.0958 17.7125 16.2875C17.9042 16.4792 18 16.7167 18 17C18 17.2833 17.9042 17.5208 17.7125 17.7125C17.5208 17.9042 17.2833 18 17 18ZM6 14C5.45 14 4.97917 13.8042 4.5875 13.4125C4.19583 13.0208 4 12.55 4 12V6C4 5.45 4.19583 4.97917 4.5875 4.5875C4.97917 4.19583 5.45 4 6 4H12C12.55 4 13.0208 4.19583 13.4125 4.5875C13.8042 4.97917 14 5.45 14 6V12C14 12.55 13.8042 13.0208 13.4125 13.4125C13.0208 13.8042 12.55 14 12 14H6Z"
      fill="#0068FF"
    />
  </svg>
);
export const InactiveGridIcon = ({ w = "20", h = "20" }) => (
  <svg
    width={w}
    height={h}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="20" height="20" fill="white" />

    <mask
      id="mask0_14823_281391"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="2"
      y="2"
      width="16"
      height="16"
    >
      <rect x="2" y="2" width="16" height="16" fill="#D9D9D9" />
    </mask>

    <g mask="url(#mask0_14823_281391)">
      <path
        d="M5.33594 9.33203C5.06327 9.33203 4.82844 9.23353 4.63144 9.03653C4.43444 8.83953 4.33594 8.6047 4.33594 8.33203V5.33203C4.33594 5.05936 4.43444 4.82453 4.63144 4.62753C4.82844 4.43053 5.06327 4.33203 5.33594 4.33203H8.33594C8.6086 4.33203 8.84344 4.43053 9.04044 4.62753C9.23744 4.82453 9.33594 5.05936 9.33594 5.33203V8.33203C9.33594 8.6047 9.23744 8.83953 9.04044 9.03653C8.84344 9.23353 8.6086 9.33203 8.33594 9.33203H5.33594ZM5.33594 15.6654C5.06327 15.6654 4.82844 15.5669 4.63144 15.3699C4.43444 15.1729 4.33594 14.938 4.33594 14.6654V11.6654C4.33594 11.3927 4.43444 11.1579 4.63144 10.9609C4.82844 10.7639 5.06327 10.6654 5.33594 10.6654H8.33594C8.6086 10.6654 8.84344 10.7639 9.04044 10.9609C9.23744 11.1579 9.33594 11.3927 9.33594 11.6654V14.6654C9.33594 14.938 8.84344 15.5669 8.33594 15.6654H5.33594ZM11.6693 9.33203C11.3966 9.33203 11.1618 9.23353 10.9648 9.03653C10.7678 8.83953 10.6693 8.6047 10.6693 8.33203V5.33203C10.6693 5.05936 10.7678 4.82453 10.9648 4.62753C11.1618 4.43053 11.3966 4.33203 11.6693 4.33203H14.6693C14.9419 4.33203 15.1768 4.43053 15.3738 4.62753C15.5708 4.82453 15.6693 5.05936 15.6693 5.33203V8.33203C15.6693 8.6047 15.5708 8.83953 15.3738 9.03653C15.1768 9.23353 14.9419 9.33203 14.6693 9.33203H11.6693ZM11.6693 15.6654C11.3966 15.6654 11.1618 15.5669 10.9648 15.3699C10.7678 15.1729 10.6693 14.938 10.6693 14.6654V11.6654C10.6693 11.3927 10.7678 11.1579 10.9648 10.9609C11.1618 10.7639 11.3966 10.6654 11.6693 10.6654H14.6693C14.9419 10.6654 15.1768 10.7639 15.3738 10.9609C15.5708 11.1579 15.6693 11.3927 15.6693 11.6654V14.6654C15.6693 14.938 15.5708 15.1729 15.3738 15.3699C15.1768 15.5669 14.9419 15.6654 14.6693 15.6654H11.6693ZM5.33594 8.33203H8.33594V5.33203H5.33594V8.33203ZM11.6693 8.33203H14.6693V5.33203H11.6693V8.33203ZM11.6693 14.6654H14.6693V11.6654H11.6693V14.6654ZM5.33594 14.6654H8.33594V11.6654H5.33594V14.6654Z"
        fill="#808080"
      />
    </g>
  </svg>
);
export const ListInactiveIcon = ({ w = "20", h = "20" }) => (
  <svg
    width={w}
    height={h}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="20" height="20" fill="white" />

    <mask
      id="mask0_14823_281426"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="2"
      y="2"
      width="16"
      height="16"
    >
      <rect x="2" y="2" width="16" height="16" fill="#D9D9D9" />
    </mask>

    <g mask="url(#mask0_14823_281426)">
      <path
        d="M8.70777 14.4996C8.5661 14.4996 8.44733 14.4517 8.35144 14.3558C8.25566 14.2599 8.20777 14.1411 8.20777 13.9995C8.20777 13.8577 8.25566 13.739 8.35144 13.6433C8.44733 13.5475 8.5661 13.4996 8.70777 13.4996H15.1693C15.3109 13.4996 15.4297 13.5476 15.5254 13.6435C15.6213 13.7393 15.6693 13.8581 15.6693 13.9998C15.6693 14.1416 15.6213 14.2603 15.5254 14.356C15.4297 14.4517 15.3109 14.4996 15.1693 14.4996H8.70777ZM8.70777 10.4996C8.5661 10.4996 8.44733 10.4517 8.35144 10.3558C8.25566 10.2599 8.20777 10.1411 8.20777 9.99946C8.20777 9.85768 8.25566 9.73896 8.35144 9.64329C8.44733 9.54751 8.5661 9.49962 8.70777 9.49962H15.1693C15.3109 9.49962 15.4297 9.54757 15.5254 9.64346C15.6213 9.73935 15.6693 9.85812 15.6693 9.99979C15.6693 10.1416 15.6213 10.2603 15.5254 10.356C15.4297 10.4517 15.3109 10.4996 15.1693 10.4996H8.70777ZM8.70777 6.49962C8.5661 6.49962 8.44733 6.45168 8.35144 6.35579C8.25566 6.2599 8.20777 6.14112 8.20777 5.99946C8.20777 5.85768 8.25566 5.73896 8.35144 5.64329C8.44733 5.54751 8.5661 5.49962 8.70777 5.49962H15.1693C15.3109 5.49962 15.4297 5.54757 15.5254 5.64346C15.6213 5.73935 15.6693 5.85812 15.6693 5.99979C15.6693 6.14157 15.6213 6.26029 15.5254 6.35596C15.4297 6.45174 15.3109 6.49962 15.1693 6.49962H8.70777ZM5.44494 15.1086C5.13994 15.1086 4.87888 15 4.66177 14.7828C4.44455 14.5657 4.33594 14.3046 4.33594 13.9996C4.33594 13.6946 4.44455 13.4336 4.66177 13.2165C4.87888 12.9992 5.13994 12.8906 5.44494 12.8906C5.74994 12.8906 6.01099 12.9992 6.2281 13.2165C6.44533 13.4336 6.55394 13.6946 6.55394 13.9996C6.55394 14.3046 6.44533 14.5657 6.2281 14.7828C6.01099 15 5.74994 15.1086 5.44494 15.1086ZM5.44494 11.1086C5.13994 11.1086 4.87888 11 4.66177 10.7828C4.44455 10.5657 4.33594 10.3046 4.33594 9.99962C4.33594 9.69462 4.44455 9.43357 4.66177 9.21646C4.87888 8.99924 5.13994 8.89062 5.44494 8.89062C5.74994 8.89062 6.01099 8.99924 6.2281 9.21646C6.44533 9.43357 6.55394 9.69462 6.55394 9.99962C6.55394 10.3046 6.44533 10.5657 6.2281 10.7828C6.01099 11 5.74994 11.1086 5.44494 11.1086ZM5.44494 7.10862C5.13994 7.10862 4.87888 7.00001 4.66177 6.78279C4.44455 6.56568 4.33594 6.30462 4.33594 5.99962C4.33594 5.69462 4.44455 5.43357 4.66177 5.21646C4.87888 4.99924 5.13994 4.89062 5.44494 4.89062C5.74994 4.89062 6.01099 4.99924 6.2281 5.21646C6.44533 5.43357 6.55394 5.69462 6.55394 5.99962C6.55394 6.30462 6.44533 6.56568 6.2281 6.78279C6.01099 7.00001 5.74994 7.10862 5.44494 7.10862Z"
        fill="#808080"
      />
    </g>
  </svg>
);
export const ActiveGridIcon = ({ w = "20", h = "20" }) => (
  <svg
    width={w}
    height={h}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="20" height="20" rx="4" fill="#0068FF" />

    <mask
      id="mask0_14823_281415"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="2"
      y="2"
      width="16"
      height="16"
    >
      <rect x="2" y="2" width="16" height="16" fill="#D9D9D9" />
    </mask>

    <g mask="url(#mask0_14823_281415)">
      <path
        d="M5.33594 9.33203C5.06327 9.33203 4.82844 9.23353 4.63144 9.03653C4.43444 8.83953 4.33594 8.6047 4.33594 8.33203V5.33203C4.33594 5.05936 4.43444 4.82453 4.63144 4.62753C4.82844 4.43053 5.06327 4.33203 5.33594 4.33203H8.33594C8.6086 4.33203 8.84344 4.43053 9.04044 4.62753C9.23744 4.82453 9.33594 5.05936 9.33594 5.33203V8.33203C9.33594 8.6047 9.23744 8.83953 9.04044 9.03653C8.84344 9.23353 8.6086 9.33203 8.33594 9.33203H5.33594ZM5.33594 15.6654C5.06327 15.6654 4.82844 15.5669 4.63144 15.3699C4.43444 15.1729 4.33594 14.938 4.33594 14.6654V11.6654C4.33594 11.3927 4.43444 11.1579 4.63144 10.9609C4.82844 10.7639 5.06327 10.6654 5.33594 10.6654H8.33594C8.6086 10.6654 8.84344 10.7639 9.04044 10.9609C9.23744 11.1579 9.33594 11.3927 9.33594 11.6654V14.6654C9.33594 14.938 9.23744 15.1729 9.04044 15.3699C8.84344 15.5669 8.6086 15.6654 8.33594 15.6654H5.33594ZM11.6693 9.33203C11.3966 9.33203 11.1618 9.23353 10.9648 9.03653C10.7678 8.83953 10.6693 8.6047 10.6693 8.33203V5.33203C10.6693 5.05936 10.7678 4.82453 10.9648 4.62753C11.1618 4.43053 11.3966 4.33203 11.6693 4.33203H14.6693C14.9419 4.33203 15.1768 4.43053 15.3738 4.62753C15.5708 4.82453 15.6693 5.05936 15.6693 5.33203V8.33203C15.6693 8.6047 15.5708 8.83953 15.3738 9.03653C15.1768 9.23353 14.9419 9.33203 14.6693 9.33203H11.6693ZM11.6693 15.6654C11.3966 15.6654 11.1618 15.5669 10.9648 15.3699C10.7678 15.1729 10.6693 14.938 10.6693 14.6654V11.6654C10.6693 11.3927 10.7678 11.1579 10.9648 10.9609C11.1618 10.7639 11.3966 10.6654 11.6693 10.6654H14.6693C14.9419 10.6654 15.1768 10.7639 15.3738 10.9609C15.5708 11.1579 15.6693 11.3927 15.6693 11.6654V14.6654C15.6693 14.938 15.5708 15.1729 15.3738 15.3699C15.1768 15.5669 14.9419 15.6654 14.6693 15.6654H11.6693ZM5.33594 8.33203H8.33594V5.33203H5.33594V8.33203ZM11.6693 8.33203H14.6693V5.33203H11.6693V8.33203ZM11.6693 14.6654H14.6693V11.6654H11.6693V14.6654ZM5.33594 14.6654H8.33594V11.6654H5.33594V14.6654Z"
        fill="white"
      />
    </g>
  </svg>
);
export const ResetIcon = ({ w = "14", h = "19" }) => (
  <svg
    width={w}
    height={h}
    viewBox="0 0 14 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.916667 12.5417C0.611111 12.0139 0.381944 11.4722 0.229167 10.9167C0.0763889 10.3611 0 9.79167 0 9.20833C0 7.34722 0.645833 5.76389 1.9375 4.45833C3.22917 3.15278 4.80556 2.5 6.66667 2.5H6.8125L5.47917 1.16667L6.64583 0L9.97917 3.33333L6.64583 6.66667L5.47917 5.5L6.8125 4.16667H6.66667C5.27778 4.16667 4.09722 4.65625 3.125 5.63542C2.15278 6.61458 1.66667 7.80556 1.66667 9.20833C1.66667 9.56944 1.70833 9.92361 1.79167 10.2708C1.875 10.6181 2 10.9583 2.16667 11.2917L0.916667 12.5417ZM6.6875 18.3333L3.35417 15L6.6875 11.6667L7.85417 12.8333L6.52083 14.1667H6.66667C8.05556 14.1667 9.23611 13.6771 10.2083 12.6979C11.1806 11.7188 11.6667 10.5278 11.6667 9.125C11.6667 8.76389 11.625 8.40972 11.5417 8.0625C11.4583 7.71528 11.3333 7.375 11.1667 7.04167L12.4167 5.79167C12.7222 6.31945 12.9514 6.86111 13.1042 7.41667C13.2569 7.97222 13.3333 8.54167 13.3333 9.125C13.3333 10.9861 12.6875 12.5694 11.3958 13.875C10.1042 15.1806 8.52778 15.8333 6.66667 15.8333H6.52083L7.85417 17.1667L6.6875 18.3333Z"
      fill="#0068FF"
    />
  </svg>
);
export const ApplyFilterIcon = ({ w = "11", h = "11" }) => (
  <svg
    width={w}
    height={h}
    viewBox="0 0 11 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.16667 10.8333L0 9.66667L8 1.66667H0.833333V0H10.8333V10H9.16667V2.83333L1.16667 10.8333Z"
      fill="white"
    />
  </svg>
);
export const CautionSvg = ({ w = "48", h = "48" }) => (
  <svg
    width={w}
    height={h}
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M24.1195 47.9999C10.7989 47.9999 0 37.2002 0 23.8694C0 17.4759 2.54038 11.3448 7.06806 6.81683C16.6296 -2.46413 31.9 -2.23913 41.1804 7.31369C50.2732 16.679 50.2732 31.566 41.1804 40.9314C36.662 45.4687 30.522 48.0187 24.1195 47.9999Z"
      fill="black"
    />
    <path
      d="M24.3149 47.3799C37.0533 47.3799 47.3799 37.0533 47.3799 24.3149C47.3799 11.5765 37.0533 1.25 24.3149 1.25C11.5765 1.25 1.25 11.5765 1.25 24.3149C1.25 37.0533 11.5765 47.3799 24.3149 47.3799Z"
      fill="#F53D3D"
    />
    <path
      d="M24.0052 29.9262C21.7257 29.9357 19.8467 28.1427 19.7704 25.8753L19.3317 14.9845C19.2363 12.6507 21.0676 10.6964 23.4043 10.6016H23.5665H24.4344C26.7807 10.6016 28.6788 12.4894 28.6788 14.8232V14.994L28.2496 25.8848C28.1637 28.1427 26.2848 29.9357 24.0052 29.9262Z"
      fill="black"
    />
    <path
      d="M24.3073 28.6811C22.536 28.6811 21.0807 27.2939 21.0041 25.5361L20.5733 14.6282C20.4967 12.8228 21.9232 11.2931 23.7424 11.2266H23.8764H24.7477C26.5668 11.2266 28.0508 12.6898 28.0508 14.5046V14.6377L27.62 25.5456C27.5338 27.2939 26.0785 28.6811 24.3073 28.6811Z"
      fill="white"
    />
    <path
      d="M24.0051 37.4008C21.7692 37.4008 19.9531 35.5847 19.9531 33.3488C19.9531 31.113 21.7692 29.2969 24.0051 29.2969C26.2409 29.2969 28.057 31.113 28.057 33.3488C28.057 35.5847 26.2409 37.4008 24.0051 37.4008Z"
      fill="black"
    />
    <path
      d="M23.6872 29.9219C25.4087 29.9219 26.8041 31.3172 26.8041 33.0388C26.8041 34.7603 25.4087 36.1556 23.6872 36.1556C21.9657 36.1556 20.5703 34.7603 20.5703 33.0388C20.5703 31.3172 21.9657 29.9219 23.6872 29.9219Z"
      fill="white"
    />
  </svg>
);
export const TimerIcon = ({ w = "15", h = "15" }) => (
  <svg
    width={w}
    height={h}
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.5 15C5.58333 15 3.91319 14.3646 2.48958 13.0938C1.06597 11.8229 0.25 10.2361 0.0416667 8.33333H1.75C1.94444 9.77778 2.58681 10.9722 3.67708 11.9167C4.76736 12.8611 6.04167 13.3333 7.5 13.3333C9.125 13.3333 10.5035 12.7674 11.6354 11.6354C12.7674 10.5035 13.3333 9.125 13.3333 7.5C13.3333 5.875 12.7674 4.49653 11.6354 3.36458C10.5035 2.23264 9.125 1.66667 7.5 1.66667C6.54167 1.66667 5.64583 1.88889 4.8125 2.33333C3.97917 2.77778 3.27778 3.38889 2.70833 4.16667H5V5.83333H0V0.833333H1.66667V2.79167C2.375 1.90278 3.23958 1.21528 4.26042 0.729167C5.28125 0.243056 6.36111 0 7.5 0C8.54167 0 9.51736 0.197917 10.4271 0.59375C11.3368 0.989583 12.1285 1.52431 12.8021 2.19792C13.4757 2.87153 14.0104 3.66319 14.4062 4.57292C14.8021 5.48264 15 6.45833 15 7.5C15 8.54167 14.8021 9.51736 14.4062 10.4271C14.0104 11.3368 13.4757 12.1285 12.8021 12.8021C12.1285 13.4757 11.3368 14.0104 10.4271 14.4062C9.51736 14.8021 8.54167 15 7.5 15ZM9.83333 11L6.66667 7.83333V3.33333H8.33333V7.16667L11 9.83333L9.83333 11Z"
      fill="#1C1B1F"
    />
  </svg>
);
export const SourceIcon = ({ w = "16", h = "12" }) => (
  <svg
    width={w}
    height={h}
    viewBox="0 0 16 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.3975 8.12667H10.2725C10.6697 8.12667 11.0121 7.98549 11.2996 7.70312C11.5871 7.42076 11.7308 7.07514 11.7308 6.66625C11.7308 6.25736 11.5899 5.91375 11.3079 5.63542C11.026 5.35708 10.6808 5.21792 10.2725 5.21792H10.0427C9.98535 4.60361 9.73757 4.07375 9.29938 3.62833C8.86104 3.18278 8.3209 2.96 7.67896 2.96C7.17285 2.96 6.72535 3.105 6.33646 3.395C5.94757 3.68514 5.6784 4.04708 5.52896 4.48083H5.23563C4.75507 4.48083 4.35639 4.66243 4.03958 5.02563C3.72264 5.38896 3.56417 5.81153 3.56417 6.29333C3.56417 6.80611 3.74153 7.23986 4.09625 7.59458C4.45083 7.94931 4.88458 8.12667 5.3975 8.12667ZM1.33979 11.1667C0.964653 11.1667 0.647569 11.0371 0.388542 10.7779C0.129514 10.5187 0 10.2015 0 9.82604V1.33396C0 0.958542 0.129514 0.642361 0.388542 0.385417C0.647569 0.128472 0.964653 0 1.33979 0H13.8269C14.202 0 14.5191 0.129583 14.7781 0.388749C15.0372 0.647916 15.1667 0.965208 15.1667 1.34062V9.83271C15.1667 10.2081 15.0372 10.5243 14.7781 10.7812C14.5191 11.0382 14.202 11.1667 13.8269 11.1667H1.33979Z"
      fill="#333333"
    />
  </svg>
);

export const ChevronRight = ({ w = "14", h = "14" }) => (
  <svg width={w} height={h} viewBox="0 0 14 14" fill="none">
    <path
      d="M5 3l4 4-4 4"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ChevronLeft = ({ w = "14", h = "14" }) => (
  <svg width={w} height={h} viewBox="0 0 14 14" fill="none">
    <path
      d="M9 11L5 7l4-4"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const Myfiles = ({ w = "20", h = "20" }) => (
  <svg
    width={w}
    height={h}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.14 4.54C17.71 4.23 17.22 4 16.69 3.87C16.34 3.77 15.96 3.72 15.58 3.72H11.86C11.28 3.72 11.24 3.66 10.93 3.25L9.53 1.39C8.88 0.53 8.37 0 6.74 0H4.42C1.98 0 0 1.98 0 4.42V15.58C0 18.02 1.98 20 4.42 20H15.58C18.02 20 20 18.02 20 15.58V8.14C20 6.65 19.27 5.34 18.14 4.54ZM12.33 14H7.67C7.28 14 6.97 13.69 6.97 13.3C6.97 12.92 7.28 12.6 7.67 12.6H12.32C12.7 12.6 13.02 12.92 13.02 13.3C13.02 13.69 12.71 14 12.33 14Z"
      fill="#0068FF"
    />
  </svg>
);
export const GoogleDriveIcon = ({ w = "24", h = "24" }) => (
  <svg
    width={w}
    height={h}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_15611_252497"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="24"
      height="24"
    >
      <rect width="24" height="24" fill="#D9D9D9" />
    </mask>

    <g mask="url(#mask0_15611_252497)">
      <path
        d="M5.49688 21.5C5.21354 21.5 4.92604 21.4125 4.63438 21.2375C4.34271 21.0625 4.13021 20.8583 3.99688 20.625L1.49688 16.25C1.36354 16.0167 1.29688 15.7292 1.29688 15.3875C1.29688 15.0458 1.36354 14.7583 1.49688 14.525L7.99688 3.375C8.13021 3.14167 8.34271 2.9375 8.63438 2.7625C8.92604 2.5875 9.21354 2.5 9.49687 2.5H14.4969C14.7802 2.5 15.0677 2.5875 15.3594 2.7625C15.651 2.9375 15.8635 3.14167 15.9969 3.375L20.5469 11.175C20.1635 11.075 19.7677 11.0083 19.3594 10.975C18.951 10.9417 18.5469 10.9583 18.1469 11.025L14.3469 4.5H9.64688L3.29688 15.4L5.64687 19.5H13.5469C13.7302 19.8833 13.9427 20.2417 14.1844 20.575C14.426 20.9083 14.7052 21.2167 15.0219 21.5H5.49688ZM7.24688 17L6.52187 15.725L11.0969 7.75H12.8969L15.4219 12.15C15.1385 12.3667 14.876 12.6042 14.6344 12.8625C14.3927 13.1208 14.1802 13.3917 13.9969 13.675L11.9969 10.2L9.24688 15H13.3469C13.2302 15.3167 13.1427 15.6417 13.0844 15.975C13.026 16.3083 12.9969 16.65 12.9969 17H7.24688Z"
        fill="#1C1B1F"
      />
      <path
        d="M22.5 15.4L21.1 14L18 17.1V14.5H16V20.5H22V18.5H19.425L22.5 15.4Z"
        fill="#1C1B1F"
      />
    </g>
  </svg>
);
export const UploadFromCompIcon = ({ w = "16", h = "20" }) => (
  <svg
    width={w}
    height={h}
    viewBox="0 0 16 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7 17H9V12.825L10.6 14.425L12 13L8 9L4 13L5.425 14.4L7 12.825V17ZM2 20C1.45 20 0.979167 19.8042 0.5875 19.4125C0.195833 19.0208 0 18.55 0 18V2C0 1.45 0.195833 0.979167 0.5875 0.5875C0.979167 0.195833 1.45 0 2 0H10L16 6V18C16 18.55 15.8042 19.0208 15.4125 19.4125C15.0208 19.8042 14.55 20 14 20H2ZM9 7V2H2V18H14V7H9Z"
      fill="#1C1B1F"
    />
  </svg>
);
export const RestoreIcon = ({ w = "17", h = "17" }) => (
  <svg
    width={w}
    height={h}
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.44025 17C6.27492 17 4.38775 16.2872 2.77875 14.8615C1.16975 13.4358 0.2435 11.6487 0 9.5H1.53075C1.78325 11.227 2.5605 12.6587 3.8625 13.7952C5.16433 14.9318 6.69025 15.5 8.44025 15.5C10.3903 15.5 12.0444 14.8208 13.4028 13.4625C14.7611 12.1042 15.4402 10.45 15.4402 8.5C15.4402 6.55 14.7611 4.89583 13.4028 3.5375C12.0444 2.17917 10.3903 1.5 8.44025 1.5C7.34792 1.5 6.32425 1.74267 5.36925 2.228C4.41408 2.71317 3.59158 3.38075 2.90175 4.23075H5.51725V5.73075H0.44025V0.653751H1.94025V3.023C2.75175 2.06533 3.72358 1.32208 4.85575 0.79325C5.98775 0.264416 7.18258 0 8.44025 0C9.61975 0 10.7249 0.223084 11.7557 0.66925C12.7864 1.11542 13.6851 1.72183 14.4518 2.4885C15.2184 3.25517 15.8248 4.15392 16.271 5.18475C16.7172 6.21542 16.9403 7.3205 16.9403 8.5C16.9403 9.6795 16.7172 10.7846 16.271 11.8152C15.8248 12.8461 15.2184 13.7448 14.4518 14.5115C13.6851 15.2782 12.7864 15.8846 11.7557 16.3307C10.7249 16.7769 9.61975 17 8.44025 17ZM11.4423 12.527L7.71925 8.80375V3.5H9.219V8.19625L12.496 11.473L11.4423 12.527Z"
      fill="#4D4D4D"
    />
  </svg>
);

export const StarIcon = ({ w = "13", h = "13" }) => (
  <svg
    width={w}
    height={h}
    viewBox="0 0 13 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.78584 10.2965L6.41084 8.71312L9.03584 10.3173L8.34834 7.31729L10.6608 5.31729L7.61917 5.04646L6.41084 2.21312L5.2025 5.02562L2.16084 5.29646L4.47334 7.31729L3.78584 10.2965ZM6.41084 10.1827L3.16896 12.1377C3.04813 12.2083 2.92708 12.2379 2.80584 12.2267C2.68458 12.2154 2.57486 12.1746 2.47667 12.1042C2.37834 12.0336 2.30243 11.9415 2.24896 11.8277C2.19563 11.714 2.18708 11.5881 2.22334 11.4502L3.08396 7.76917L0.221877 5.29167C0.114932 5.19875 0.0468071 5.09111 0.0175016 4.96875C-0.0119429 4.84639 -0.00423455 4.7275 0.0406266 4.61208C0.0854877 4.49681 0.15014 4.40257 0.234585 4.32937C0.319029 4.25618 0.434446 4.20833 0.580835 4.18583L4.35792 3.85583L5.82438 0.379791C5.87771 0.250486 5.95861 0.15486 6.06709 0.0929159C6.17556 0.0309714 6.29014 0 6.41084 0C6.53153 0 6.64611 0.0309714 6.75459 0.0929159C6.86306 0.15486 6.94396 0.250486 6.99729 0.379791L8.46375 3.85583L12.2408 4.18583C12.3872 4.20833 12.5026 4.25618 12.5871 4.32937C12.6715 4.40257 12.7362 4.49681 12.781 4.61208C12.8259 4.7275 12.8336 4.84639 12.8042 4.96875C12.7749 5.09111 12.7067 5.19875 12.5998 5.29167L9.73771 7.76917L10.5983 11.4502C10.6346 11.5881 10.626 11.714 10.5727 11.8277C10.5192 11.9415 10.4433 12.0336 10.345 12.1042C10.2468 12.1746 10.1371 12.2154 10.0158 12.2267C9.89459 12.2379 9.77354 12.2083 9.65271 12.1377L6.41084 10.1827Z"
      fill="#4D4D4D"
    />
  </svg>
);
export const ActiveStarIcon = ({ w = "18", h = "18" }) => (
  <svg
    width={w}
    height={h}
    viewBox="0 0 11 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.03906 3.95312L1.03906 4.45312L3.03906 6.45312L2.53906 9.45312L5.03906 7.95312L7.53906 9.45312L7.03906 6.45312L9.03906 4.45312H6.03906L5.03906 1.45312L4.03906 3.95312Z"
      fill="#FFBA00"
      stroke="#FFBA00"
      stroke-linecap="round"
    />
  </svg>
);

export const DownloadIcon = ({ w = "14", h = "14" }) => (
  <svg
    width={w}
    height={h}
    viewBox="0 0 13 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.25 9.09292C6.14958 9.09292 6.05611 9.07687 5.96958 9.04479C5.88306 9.01285 5.80076 8.95785 5.72271 8.87979L3.13146 6.28854C3.00757 6.16451 2.94639 6.01944 2.94792 5.85333C2.94958 5.68722 3.01076 5.53951 3.13146 5.41021C3.26076 5.28104 3.40924 5.21431 3.57687 5.21C3.74465 5.20569 3.89319 5.26819 4.0225 5.3975L5.625 7V0.625C5.625 0.447639 5.68486 0.299167 5.80458 0.179583C5.92417 0.059861 6.07264 0 6.25 0C6.42736 0 6.57583 0.059861 6.69542 0.179583C6.81514 0.299167 6.875 0.447639 6.875 0.625V7L8.4775 5.3975C8.60153 5.27361 8.74868 5.21243 8.91896 5.21396C9.08937 5.21563 9.23924 5.28104 9.36854 5.41021C9.48924 5.53951 9.55174 5.6859 9.55604 5.84937C9.56035 6.01285 9.49785 6.15924 9.36854 6.28854L6.77729 8.87979C6.69924 8.95785 6.61694 9.01285 6.53042 9.04479C6.44389 9.07687 6.35042 9.09292 6.25 9.09292ZM1.50646 12.5C1.08549 12.5 0.729167 12.3542 0.4375 12.0625C0.145833 11.7708 0 11.4145 0 10.9935V9.35896C0 9.1816 0.059861 9.03312 0.179583 8.91354C0.299167 8.79382 0.447639 8.73396 0.625 8.73396C0.802361 8.73396 0.950833 8.79382 1.07042 8.91354C1.19014 9.03312 1.25 9.1816 1.25 9.35896V10.9935C1.25 11.0577 1.27674 11.1165 1.33021 11.1698C1.38354 11.2233 1.44229 11.25 1.50646 11.25H10.9935C11.0577 11.25 11.1165 11.2233 11.1698 11.1698C11.2233 11.1165 11.25 11.0577 11.25 10.9935V9.35896C11.25 9.1816 11.3099 9.03312 11.4296 8.91354C11.5492 8.79382 11.6976 8.73396 11.875 8.73396C12.0524 8.73396 12.2008 8.79382 12.3204 8.91354C12.4401 9.03312 12.5 9.1816 12.5 9.35896V10.9935C12.5 11.4145 12.3542 11.7708 12.0625 12.0625C11.7708 12.3542 11.4145 12.5 10.9935 12.5H1.50646Z"
      fill="#4D4D4D"
    />
  </svg>
);

const XlsxIcon = ({ w = "15", h = "20" }) => (
  <svg
    width={w}
    height={h}
    viewBox="0 0 15 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.59853 0H9.29196L14.9562 5.91241V17.3942C14.9562 18.8321 13.7956 20 12.3577 20H2.59853C1.16788 20 0 18.8321 0 17.3942V2.59853C0 1.16788 1.16788 0 2.59853 0Z"
      fill="#084628"
    />
    <path
      opacity="0.302"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.26562 0V5.86131H14.9372L9.26562 0Z"
      fill="white"
    />
    <path
      d="M4.32449 10.3043L4.68764 10.9326H4.70318L5.07022 10.3043H5.60817L5.00808 11.2987L5.62759 12.293H5.07605L4.70318 11.6579H4.68764L4.31477 12.293H3.76712L4.38372 11.2987L3.78266 10.3043H4.32449ZM5.91143 12.293V10.3043H6.39208V11.9026H7.21939V12.293H5.91143ZM8.59781 10.9005C8.59134 10.8293 8.56253 10.774 8.51139 10.7345C8.4609 10.6944 8.38872 10.6743 8.29485 10.6743C8.23271 10.6743 8.18092 10.6824 8.13949 10.6986C8.09806 10.7147 8.06699 10.7371 8.04627 10.7656C8.02556 10.7934 8.01488 10.8254 8.01423 10.8617C8.01294 10.8915 8.01876 10.9177 8.03171 10.9403C8.0453 10.963 8.06472 10.9831 8.08997 11.0005C8.11586 11.0174 8.14694 11.0323 8.18319 11.0452C8.21944 11.0582 8.26022 11.0695 8.30554 11.0792L8.47643 11.118C8.57483 11.1394 8.66157 11.1679 8.73667 11.2035C8.8124 11.2391 8.87584 11.2815 8.92698 11.3307C8.97877 11.3799 9.01794 11.4365 9.04448 11.5006C9.07102 11.5647 9.08461 11.6366 9.08526 11.7162C9.08461 11.8418 9.05289 11.9496 8.9901 12.0395C8.92731 12.1295 8.837 12.1985 8.71919 12.2464C8.60202 12.2943 8.46057 12.3182 8.29485 12.3182C8.12849 12.3182 7.98348 12.2933 7.85984 12.2434C7.7362 12.1936 7.64007 12.1179 7.57145 12.0162C7.50283 11.9146 7.46755 11.7861 7.46561 11.6307H7.92587C7.92975 11.6948 7.94691 11.7482 7.97733 11.791C8.00776 11.8337 8.04951 11.866 8.10259 11.8881C8.15632 11.9101 8.21847 11.9211 8.28903 11.9211C8.35376 11.9211 8.40879 11.9123 8.4541 11.8949C8.50006 11.8774 8.53534 11.8531 8.55994 11.822C8.58454 11.791 8.59716 11.7554 8.59781 11.7152C8.59716 11.6777 8.58551 11.6456 8.56285 11.6191C8.5402 11.5919 8.50524 11.5686 8.45798 11.5492C8.41138 11.5291 8.35182 11.5107 8.27932 11.4938L8.07152 11.4453C7.89933 11.4058 7.76371 11.342 7.66467 11.254C7.56562 11.1653 7.51642 11.0455 7.51707 10.8947C7.51642 10.7717 7.54944 10.6639 7.61612 10.5714C7.68279 10.4788 7.77504 10.4066 7.89285 10.3548C8.01067 10.303 8.14499 10.2771 8.29582 10.2771C8.44989 10.2771 8.58357 10.3034 8.69685 10.3558C8.81079 10.4076 8.89915 10.4804 8.96194 10.5743C9.02473 10.6681 9.05678 10.7769 9.05807 10.9005H8.59781ZM9.86918 10.3043L10.2323 10.9326H10.2479L10.6149 10.3043H11.1529L10.5528 11.2987L11.1723 12.293H10.6207L10.2479 11.6579H10.2323L9.85947 12.293H9.31182L9.92841 11.2987L9.32735 10.3043H9.86918Z"
      fill="white"
    />
  </svg>
);

const DocIcon = ({ w = "15", h = "20" }) => (
  <svg
    width={w}
    height={h}
    viewBox="0 0 15 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.60177 0H9.2936L14.9582 5.90996V17.3982C14.9582 18.8353 13.7935 20 12.3564 20H2.60177C1.16472 20 0 18.8353 0 17.3982V2.60177C0 1.16474 1.16472 0 2.60177 0Z"
      fill="#0263D1"
    />
    <path
      opacity="0.302"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.28125 0V5.86141H14.9539L9.28125 0Z"
      fill="white"
    />
    <path
      d="M2.41406 14.2705V10.9596H3.58689C3.82145 10.9596 4.03986 10.9947 4.24207 11.0594C4.44428 11.1268 4.62761 11.2239 4.79209 11.3533C4.95655 11.4827 5.08598 11.6553 5.18034 11.8709C5.2747 12.0866 5.32324 12.3347 5.32324 12.6151C5.32324 12.8955 5.2747 13.1435 5.18034 13.3592C5.08598 13.5749 4.95655 13.7474 4.79209 13.8768C4.62763 14.0062 4.44428 14.1033 4.24207 14.1707C4.03986 14.2354 3.82147 14.2705 3.58689 14.2705H2.41406ZM3.24178 13.5506H3.48713C3.61924 13.5506 3.74326 13.5345 3.85379 13.5048C3.96703 13.4724 4.06947 13.4212 4.16653 13.3538C4.26359 13.2864 4.33908 13.1893 4.393 13.0626C4.44963 12.9386 4.47657 12.7876 4.47657 12.6151C4.47657 12.4425 4.44961 12.2915 4.393 12.1648C4.33908 12.0408 4.26359 11.9437 4.16653 11.8763C4.06947 11.8062 3.96703 11.7577 3.85379 11.7253C3.74326 11.6957 3.61924 11.6795 3.48713 11.6795H3.24178V13.5506ZM7.33185 14.3082C6.83307 14.3082 6.42056 14.1465 6.09433 13.8256C5.76809 13.5048 5.60631 13.1004 5.60631 12.6151C5.60631 12.1298 5.76809 11.7254 6.09433 11.4045C6.42056 11.0837 6.83307 10.9219 7.33185 10.9219C7.82254 10.9219 8.22966 11.0837 8.5559 11.4045C8.87943 11.7254 9.04121 12.1298 9.04121 12.6151C9.04121 13.1004 8.87943 13.5048 8.5559 13.8256C8.22966 14.1465 7.82254 14.3082 7.33185 14.3082ZM6.69555 13.3134C6.86001 13.4967 7.0703 13.5884 7.32644 13.5884C7.58257 13.5884 7.79017 13.4967 7.95465 13.3134C8.11911 13.1273 8.2 12.8955 8.2 12.6151C8.2 12.3347 8.11911 12.1028 7.95465 11.9168C7.79019 11.7334 7.58257 11.6417 7.32644 11.6417C7.0703 11.6417 6.86001 11.7334 6.69555 11.9168C6.53109 12.1028 6.4475 12.3347 6.4475 12.6151C6.4475 12.8955 6.53109 13.1273 6.69555 13.3134ZM11.0094 14.3082C10.5268 14.3082 10.125 14.1573 9.80691 13.8607C9.48606 13.5614 9.32701 13.1462 9.32701 12.6151C9.32701 12.0866 9.48879 11.6714 9.81232 11.3721C10.1386 11.0729 10.5349 10.9219 11.0094 10.9219C11.4381 10.9219 11.7886 11.027 12.0663 11.24C12.3413 11.4503 12.5004 11.7307 12.5408 12.0812L11.705 12.2511C11.67 12.0677 11.5864 11.9195 11.457 11.8089C11.3276 11.6983 11.1766 11.6417 11.004 11.6417C10.7667 11.6417 10.5699 11.7253 10.4108 11.8952C10.2518 12.0677 10.1709 12.305 10.1709 12.615C10.1709 12.9251 10.2518 13.1624 10.4081 13.3322C10.5672 13.5048 10.764 13.5884 11.004 13.5884C11.1765 13.5884 11.3248 13.5398 11.4461 13.4428C11.5675 13.3457 11.643 13.2163 11.6753 13.0545L12.53 13.2487C12.4518 13.583 12.2792 13.8418 12.0096 14.0278C11.7427 14.2139 11.4084 14.3082 11.0094 14.3082Z"
      fill="white"
    />
  </svg>
);
const PngIcon = ({ w = "15", h = "20" }) => (
  <svg
    width={w}
    height={h}
    viewBox="0 0 15 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.60177 0H9.2936L14.9582 5.90996V17.3982C14.9582 18.8353 13.7935 20 12.3564 20H2.60177C1.16472 20 0 18.8353 0 17.3982V2.60177C0 1.16474 1.16472 0 2.60177 0Z"
      fill="#3452AF"
    />
    <path
      opacity="0.302"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.28125 0V5.86141H14.9539L9.28125 0Z"
      fill="#7D8175"
    />
    <path
      d="M2.22676 14.6172V11.2081H3.63501C3.89025 11.2081 4.11053 11.258 4.29585 11.3579C4.48229 11.4567 4.626 11.5948 4.72698 11.7724C4.82797 11.9488 4.87846 12.1541 4.87846 12.3883C4.87846 12.6236 4.82686 12.8294 4.72365 13.0059C4.62156 13.1812 4.47563 13.3171 4.28587 13.4137C4.0961 13.5102 3.87083 13.5585 3.61004 13.5585H2.74112V12.9093H3.4569C3.58119 12.9093 3.68495 12.8877 3.76818 12.8444C3.85252 12.8011 3.91633 12.7406 3.95961 12.663C4.00289 12.5842 4.02453 12.4926 4.02453 12.3883C4.02453 12.2829 4.00289 12.1919 3.95961 12.1153C3.91633 12.0376 3.85252 11.9777 3.76818 11.9355C3.68384 11.8934 3.58008 11.8723 3.4569 11.8723H3.05074V14.6172H2.22676ZM8.27976 11.2081V14.6172H7.58063L6.22399 12.6496H6.20235V14.6172H5.37837V11.2081H6.08749L7.42915 13.1723H7.45745V11.2081H8.27976ZM11.1288 12.3217C11.11 12.2518 11.0822 12.1902 11.0456 12.1369C11.009 12.0826 10.964 12.0365 10.9108 11.9988C10.8575 11.961 10.7965 11.9328 10.7277 11.9139C10.6589 11.8939 10.5834 11.8839 10.5013 11.8839C10.3359 11.8839 10.1928 11.9239 10.0718 12.0038C9.95197 12.0837 9.8593 12.2002 9.79383 12.3533C9.72835 12.5054 9.69562 12.6901 9.69562 12.9076C9.69562 13.1263 9.72724 13.3127 9.7905 13.467C9.85375 13.6212 9.94531 13.7388 10.0652 13.8198C10.185 13.9009 10.3304 13.9414 10.5013 13.9414C10.6522 13.9414 10.7798 13.9169 10.8841 13.8681C10.9896 13.8182 11.0695 13.7477 11.1238 13.6567C11.1782 13.5657 11.2054 13.4586 11.2054 13.3354L11.3585 13.3538H10.5296V12.7528H11.9994V13.2039C11.9994 13.5091 11.9345 13.7705 11.8047 13.988C11.6759 14.2055 11.4984 14.3725 11.272 14.489C11.0467 14.6055 10.7876 14.6638 10.4946 14.6638C10.1695 14.6638 9.88372 14.5933 9.63736 14.4524C9.391 14.3115 9.19901 14.1106 9.06141 13.8498C8.9238 13.5879 8.855 13.2772 8.855 12.9176C8.855 12.638 8.89661 12.39 8.97984 12.1736C9.06307 11.9561 9.17904 11.7718 9.32774 11.6209C9.47756 11.47 9.65067 11.3557 9.8471 11.278C10.0446 11.2003 10.2571 11.1615 10.4846 11.1615C10.6822 11.1615 10.8658 11.1898 11.0356 11.2464C11.2065 11.303 11.3574 11.3829 11.4884 11.4861C11.6204 11.5893 11.7275 11.7119 11.8097 11.854C11.8918 11.996 11.9428 12.1519 11.9628 12.3217H11.1288Z"
      fill="white"
    />
  </svg>
);

export const DeleteIcon = ({ w = "13", h = "15" }) => (
  <svg
    width={w}
    height={h}
    viewBox="0 0 13 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.33979 14.0704C1.92549 14.0704 1.57083 13.9229 1.27583 13.6279C0.980833 13.3329 0.833333 12.9783 0.833333 12.564V1.98708H0.625C0.447917 1.98708 0.299514 1.92715 0.179792 1.80729C0.0599307 1.68743 0 1.53896 0 1.36188C0 1.18465 0.0599307 1.03625 0.179792 0.916667C0.299514 0.796944 0.447917 0.737083 0.625 0.737083H3.75C3.75 0.533056 3.82188 0.359167 3.96563 0.215417C4.10924 0.0718061 4.28306 0 4.48708 0H8.01292C8.21694 0 8.39076 0.0718061 8.53438 0.215417C8.67813 0.359167 8.75 0.533056 8.75 0.737083H11.875C12.0521 0.737083 12.2005 0.797014 12.3202 0.916875C12.4401 1.03674 12.5 1.18521 12.5 1.36229C12.5 1.53951 12.4401 1.68792 12.3202 1.8075C12.2005 1.92722 12.0521 1.98708 11.875 1.98708H11.6667V12.564C11.6667 12.9783 11.5192 13.3329 11.2242 13.6279C10.9292 13.9229 10.5745 14.0704 10.1602 14.0704H2.33979ZM10.4167 1.98708H2.08333V12.564C2.08333 12.6388 2.10736 12.7003 2.15542 12.7483C2.20347 12.7964 2.26493 12.8204 2.33979 12.8204H10.1602C10.2351 12.8204 10.2965 12.7964 10.3446 12.7483C10.3926 12.7003 10.4167 12.6388 10.4167 12.564V1.98708ZM4.71188 11.1538C4.88896 11.1538 5.03736 11.0939 5.15708 10.9742C5.27667 10.8543 5.33646 10.7058 5.33646 10.5288V4.27875C5.33646 4.10167 5.27653 3.95319 5.15667 3.83333C5.03694 3.71361 4.88847 3.65375 4.71125 3.65375C4.53417 3.65375 4.38576 3.71361 4.26604 3.83333C4.14646 3.95319 4.08667 4.10167 4.08667 4.27875V10.5288C4.08667 10.7058 4.14653 10.8543 4.26625 10.9742C4.38611 11.0939 4.53465 11.1538 4.71188 11.1538ZM7.78875 11.1538C7.96583 11.1538 8.11424 11.0939 8.23396 10.9742C8.35354 10.8543 8.41333 10.7058 8.41333 10.5288V4.27875C8.41333 4.10167 8.35347 3.95319 8.23375 3.83333C8.11389 3.71361 7.96535 3.65375 7.78813 3.65375C7.61104 3.65375 7.46264 3.71361 7.34292 3.83333C7.22333 3.95319 7.16354 4.10167 7.16354 4.27875V10.5288C7.16354 10.7058 7.22347 10.8543 7.34333 10.9742C7.46305 11.0939 7.61153 11.1538 7.78875 11.1538Z"
      fill="#4D4D4D"
    />
  </svg>
);
export const EditIcon = ({ w = "15", h = "15" }) => (
  <svg
    width={w}
    height={h}
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.25 12.9167H2.30125L10.8317 4.38625L9.78042 3.335L1.25 11.8654V12.9167ZM0 14.1667V11.3463L10.9921 0.358958C11.1181 0.244513 11.2572 0.156111 11.4094 0.09375C11.5617 0.03125 11.7215 0 11.8885 0C12.0556 0 12.2174 0.0296532 12.374 0.0889587C12.5306 0.148264 12.6693 0.242569 12.79 0.371875L13.8077 1.40229C13.937 1.52299 14.0292 1.66188 14.0842 1.81896C14.1392 1.97604 14.1667 2.13312 14.1667 2.29021C14.1667 2.45785 14.1381 2.61778 14.0808 2.77C14.0236 2.92236 13.9326 3.06153 13.8077 3.1875L2.82042 14.1667H0ZM10.2969 3.86979L9.78042 3.335L10.8317 4.38625L10.2969 3.86979Z"
      fill="#333333"
    />
  </svg>
);
export const MoveIcon = ({ w = "17", h = "17" }) => (
  <svg
    width={w}
    height={h}
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.04479 16.0896L4.79167 12.8365L5.68271 11.9454L7.41979 13.6827V8.66979H2.41979L4.15688 10.3942L3.25313 11.2979L0 8.04479L3.24021 4.80438L4.13125 5.69542L2.40688 7.41979H7.41979V2.40688L5.68271 4.14417L4.79167 3.25313L8.04479 0L11.2979 3.25313L10.4069 4.14417L8.66979 2.40688V7.41979H13.6698L11.9327 5.69542L12.8365 4.79167L16.0896 8.04479L12.8365 11.2979L11.9454 10.4069L13.6827 8.66979H8.66979V13.6698L10.3942 11.9327L11.2979 12.8365L8.04479 16.0896Z"
      fill="#333333"
    />
  </svg>
);
export const UploadFileIcon = ({ w = "20", h = "20" }) => (
  <svg
    width={w}
    height={h}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.4"
      d="M13.1036 1.66406H6.90365C6.58698 1.66406 6.32031 1.93073 6.32031 2.2474C6.32031 2.56406 6.58698 2.83073 6.90365 2.83073H9.62031L10.787 4.38073C11.0453 4.7224 11.0786 4.7724 11.562 4.7724H14.662C14.9786 4.7724 15.287 4.81406 15.587 4.8974C15.6203 5.0474 15.637 5.1974 15.637 5.35573V5.6474C15.637 5.96406 15.9036 6.23073 16.2203 6.23073C16.537 6.23073 16.8036 5.96406 16.8036 5.6474V5.3474C16.787 3.31406 15.137 1.66406 13.1036 1.66406Z"
      fill="#0068FF"
    />
    <path
      d="M16.7807 5.4474C16.4224 5.18906 16.0141 4.9974 15.5724 4.88906C15.2807 4.80573 14.9641 4.76406 14.6474 4.76406H11.5474C11.0641 4.76406 11.0307 4.71406 10.7724 4.3724L9.60573 2.8224C9.06406 2.10573 8.63906 1.66406 7.28073 1.66406H5.3474C3.31406 1.66406 1.66406 3.31406 1.66406 5.3474V14.6474C1.66406 16.6807 3.31406 18.3307 5.3474 18.3307H14.6474C16.6807 18.3307 18.3307 16.6807 18.3307 14.6474V8.4474C18.3307 7.20573 17.7224 6.11406 16.7807 5.4474ZM11.9391 13.3307H8.05573C7.73073 13.3307 7.4724 13.0724 7.4724 12.7474C7.4724 12.4307 7.73073 12.1641 8.05573 12.1641H11.9307C12.2474 12.1641 12.5141 12.4307 12.5141 12.7474C12.5141 13.0724 12.2557 13.3307 11.9391 13.3307Z"
      fill="#0068FF"
    />
  </svg>
);
export const BackIcon = ({ w = "16", h = "12" }) => (
  <svg
    width={w}
    height={h}
    viewBox="0 0 16 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6 12L0 6L6 0L7.4 1.45L3.85 5H16V7H3.85L7.4 10.55L6 12Z"
      fill="#1C1B1F"
    />
  </svg>
);
export const RefreshIcon = ({ w = "16", h = "22" }) => (
  <svg
    width={w}
    height={h}
    viewBox="0 0 16 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.1 15.05C0.733333 14.4167 0.458333 13.7667 0.275 13.1C0.0916667 12.4333 0 11.75 0 11.05C0 8.81667 0.775 6.91667 2.325 5.35C3.875 3.78333 5.76667 3 8 3H8.175L6.575 1.4L7.975 0L11.975 4L7.975 8L6.575 6.6L8.175 5H8C6.33333 5 4.91667 5.5875 3.75 6.7625C2.58333 7.9375 2 9.36667 2 11.05C2 11.4833 2.05 11.9083 2.15 12.325C2.25 12.7417 2.4 13.15 2.6 13.55L1.1 15.05ZM8.025 22L4.025 18L8.025 14L9.425 15.4L7.825 17H8C9.66667 17 11.0833 16.4125 12.25 15.2375C13.4167 14.0625 14 12.6333 14 10.95C14 10.5167 13.95 10.0917 13.85 9.675C13.75 9.25833 13.6 8.85 13.4 8.45L14.9 6.95C15.2667 7.58333 15.5417 8.23333 15.725 8.9C15.9083 9.56667 16 10.25 16 10.95C16 13.1833 15.225 15.0833 13.675 16.65C12.125 18.2167 10.2333 19 8 19H7.825L9.425 20.6L8.025 22Z"
      fill="#1C1B1F"
    />
  </svg>
);
export const DateIcon = ({ w = "24", h = "24" }) => (
  <svg
    width={w}
    height={h}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.7502 3.56V2C16.7502 1.59 16.4102 1.25 16.0002 1.25C15.5902 1.25 15.2502 1.59 15.2502 2V3.5H8.75023V2C8.75023 1.59 8.41023 1.25 8.00023 1.25C7.59023 1.25 7.25023 1.59 7.25023 2V3.56C4.55023 3.81 3.24023 5.42 3.04023 7.81C3.02023 8.1 3.26023 8.34 3.54023 8.34H20.4602C20.7502 8.34 20.9902 8.09 20.9602 7.81C20.7602 5.42 19.4502 3.81 16.7502 3.56Z"
      fill="#0068FF"
    />
    <path
      opacity="0.4"
      d="M20 9.84375C20.55 9.84375 21 10.2937 21 10.8438V17.0038C21 20.0038 19.5 22.0038 16 22.0038H8C4.5 22.0038 3 20.0038 3 17.0038V10.8438C3 10.2937 3.45 9.84375 4 9.84375H20Z"
      fill="#0068FF"
    />
    <path
      d="M8.5 14.9989C8.24 14.9989 7.98 14.8889 7.79 14.7089C7.61 14.5189 7.5 14.2589 7.5 13.9989C7.5 13.7389 7.61 13.4789 7.79 13.2889C8.07 13.0089 8.51 12.9189 8.88 13.0789C9.01 13.1289 9.12 13.1989 9.21 13.2889C9.39 13.4789 9.5 13.7389 9.5 13.9989C9.5 14.2589 9.39 14.5189 9.21 14.7089C9.02 14.8889 8.76 14.9989 8.5 14.9989Z"
      fill="#0068FF"
    />
    <path
      d="M12 14.9989C11.74 14.9989 11.48 14.8889 11.29 14.7089C11.11 14.5189 11 14.2589 11 13.9989C11 13.7389 11.11 13.4789 11.29 13.2889C11.38 13.1989 11.49 13.1289 11.62 13.0789C11.99 12.9189 12.43 13.0089 12.71 13.2889C12.89 13.4789 13 13.7389 13 13.9989C13 14.2589 12.89 14.5189 12.71 14.7089C12.66 14.7489 12.61 14.7889 12.56 14.8289C12.5 14.8689 12.44 14.8989 12.38 14.9189C12.32 14.9489 12.26 14.9689 12.2 14.9789C12.13 14.9889 12.07 14.9989 12 14.9989Z"
      fill="#0068FF"
    />
    <path
      d="M15.5 15C15.24 15 14.98 14.89 14.79 14.71C14.61 14.52 14.5 14.26 14.5 14C14.5 13.74 14.61 13.48 14.79 13.29C14.89 13.2 14.99 13.13 15.12 13.08C15.3 13 15.5 12.98 15.7 13.02C15.76 13.03 15.82 13.05 15.88 13.08C15.94 13.1 16 13.13 16.06 13.17C16.11 13.21 16.16 13.25 16.21 13.29C16.39 13.48 16.5 13.74 16.5 14C16.5 14.26 16.39 14.52 16.21 14.71C16.16 14.75 16.11 14.79 16.06 14.83C16 14.87 15.94 14.9 15.88 14.92C15.82 14.95 15.76 14.97 15.7 14.98C15.63 14.99 15.56 15 15.5 15Z"
      fill="#0068FF"
    />
    <path
      d="M8.5 18.5C8.37 18.5 8.24 18.47 8.12 18.42C7.99 18.37 7.89 18.3 7.79 18.21C7.61 18.02 7.5 17.76 7.5 17.5C7.5 17.24 7.61 16.98 7.79 16.79C7.89 16.7 7.99 16.63 8.12 16.58C8.3 16.5 8.5 16.48 8.7 16.52C8.76 16.53 8.82 16.55 8.88 16.58C8.94 16.6 9 16.63 9.06 16.67C9.11 16.71 9.16 16.75 9.21 16.79C9.39 16.98 9.5 17.24 9.5 17.5C9.5 17.76 9.39 18.02 9.21 18.21C9.16 18.25 9.11 18.3 9.06 18.33C9 18.37 8.94 18.4 8.88 18.42C8.82 18.45 8.76 18.47 8.7 18.48C8.63 18.49 8.57 18.5 8.5 18.5Z"
      fill="#0068FF"
    />
    <path
      d="M12 18.5031C11.74 18.5031 11.48 18.3931 11.29 18.2131C11.11 18.0231 11 17.7631 11 17.5031C11 17.2431 11.11 16.9831 11.29 16.7931C11.66 16.4231 12.34 16.4231 12.71 16.7931C12.89 16.9831 13 17.2431 13 17.5031C13 17.7631 12.89 18.0231 12.71 18.2131C12.52 18.3931 12.26 18.5031 12 18.5031Z"
      fill="#0068FF"
    />
    <path
      d="M15.5 18.5031C15.24 18.5031 14.98 18.3931 14.79 18.2131C14.61 18.0231 14.5 17.7631 14.5 17.5031C14.5 17.2431 14.61 16.9831 14.79 16.7931C15.16 16.4231 15.84 16.4231 16.21 16.7931C16.39 16.9831 16.5 17.2431 16.5 17.5031C16.5 17.7631 16.39 18.0231 16.21 18.2131C16.02 18.3931 15.76 18.5031 15.5 18.5031Z"
      fill="#0068FF"
    />
  </svg>
);
export const NoFileIcon = ({ w = "49", h = "61" }) => (
  <svg
    width={w}
    height={h}
    viewBox="0 0 49 61"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M39.1679 3.86719V52.4102H3.85156V56.2696H43.0273V3.86719H39.1679Z"
      fill="#9EA3AD"
    />
    <path
      opacity="0.08"
      d="M3.85156 54.3981H41.1558V3.86719H39.1679V52.4102H3.85156V54.3981Z"
      fill="black"
    />
    <path
      d="M9.96499 0.0546875L0.0546875 9.96499V52.4571H39.2304V0.0546875H9.96499Z"
      fill="#F6F0F5"
    />
    <path
      d="M22.6253 48.3912C30.3747 48.3912 36.6568 42.109 36.6568 34.3596C36.6568 26.6102 30.3747 20.3281 22.6253 20.3281C14.8759 20.3281 8.59375 26.6102 8.59375 34.3596C8.59375 42.109 14.8759 48.3912 22.6253 48.3912Z"
      fill="#0068FF"
    />
    <path
      d="M29.7094 41.4438C25.8016 45.3517 19.4404 45.3517 15.5325 41.4438C11.6246 37.5359 11.6246 31.1747 15.5325 27.2668C19.4404 23.359 25.8016 23.359 29.7094 27.2668C33.627 31.1747 33.627 37.5359 29.7094 41.4438Z"
      fill="#F5F9FF"
    />
    <path
      d="M35.6295 45.0191L33.6417 43.0312C33.3023 43.4579 32.9435 43.8749 32.5459 44.2725C32.1483 44.67 31.7314 45.0288 31.3047 45.3682L33.2926 47.3561C33.0695 48.3646 33.3411 49.4506 34.1168 50.2361L43.0671 59.1864C44.2792 60.3985 46.2477 60.3985 47.4598 59.1864C48.672 57.9743 48.672 56.0058 47.4598 54.7937L38.5095 45.8434C37.7241 45.0579 36.638 44.7864 35.6295 45.0191Z"
      fill="#001B42"
    />
    <path d="M9.9103 9.9103V0L0 9.9103H9.9103Z" fill="#9EA3AD" />
    <path
      d="M23.6523 34.3588L26.8426 31.1685C27.1238 30.8873 27.1238 30.4218 26.8426 30.1406C26.5614 29.8594 26.0959 29.8594 25.8147 30.1406L22.6244 33.3309L19.4341 30.1406C19.1529 29.8594 18.6874 29.8594 18.4062 30.1406C18.125 30.4218 18.125 30.8873 18.4062 31.1685L21.5965 34.3588L18.4062 37.5491C18.125 37.8303 18.125 38.2957 18.4062 38.577C18.5517 38.7224 18.7359 38.7903 18.9202 38.7903C19.1044 38.7903 19.2886 38.7224 19.4341 38.577L22.6244 35.3867L25.8147 38.577C25.9602 38.7224 26.1444 38.7903 26.3286 38.7903C26.5129 38.7903 26.6971 38.7224 26.8426 38.577C27.1238 38.2957 27.1238 37.8303 26.8426 37.5491L23.6523 34.3588Z"
      fill="#001B42"
    />
    <path
      d="M15.407 5.0483H33.7827C34.1803 5.0483 34.51 4.7186 34.51 4.32102C34.51 3.92345 34.1803 3.59375 33.7827 3.59375H15.407C15.0094 3.59375 14.6797 3.92345 14.6797 4.32102C14.6797 4.7186 15.0094 5.0483 15.407 5.0483Z"
      fill="#C3B8C3"
    />
    <path
      d="M33.773 7.46875H15.407C15.0094 7.46875 14.6797 7.79845 14.6797 8.19602C14.6797 8.5936 15.0094 8.9233 15.407 8.9233H33.7827C34.1803 8.9233 34.51 8.5936 34.51 8.19602C34.51 7.79845 34.1803 7.46875 33.773 7.46875Z"
      fill="#C3B8C3"
    />
    <path
      d="M33.7742 11.3594H24.1257C23.7281 11.3594 23.3984 11.6891 23.3984 12.0866C23.3984 12.4842 23.7281 12.8139 24.1257 12.8139H33.7742C34.1718 12.8139 34.5015 12.4842 34.5015 12.0866C34.5015 11.6891 34.1815 11.3594 33.7742 11.3594Z"
      fill="#C3B8C3"
    />
    <path
      d="M33.7742 15.2344H24.1257C23.7281 15.2344 23.3984 15.5641 23.3984 15.9616C23.3984 16.3592 23.7281 16.6889 24.1257 16.6889H33.7742C34.1718 16.6889 34.5015 16.3592 34.5015 15.9616C34.5015 15.5641 34.1815 15.2344 33.7742 15.2344Z"
      fill="#C3B8C3"
    />
  </svg>
);
export const DragFileIcon = ({ w = "49", h = "61" }) => (
  <svg
    width="57"
    height="61"
    viewBox="0 0 57 61"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.22842 4.13159H42.625V0H0V56.25H4.22842V4.13159Z"
      fill="#9EA3AD"
    />
    <path d="M7.67969 7.64844H46.487V60.0606H7.67969V7.64844Z" fill="#F6F0F5" />
    <path
      d="M7.67189 7.64846H42.6198V3.78906H3.8125V56.2109H7.67189V7.64846Z"
      fill="#E1D9E1"
    />
    <path
      d="M37.7878 14.4766H16.4642C16.406 14.4766 16.3672 14.5347 16.3672 14.6026V22.2147H37.7878V14.4766Z"
      fill="#C3B8C3"
    />
    <path
      d="M42.6167 29.767H11.5476C11.15 29.767 10.8203 29.4373 10.8203 29.0398C10.8203 28.6422 11.15 28.3125 11.5476 28.3125H42.6167C43.0143 28.3125 43.344 28.6422 43.344 29.0398C43.344 29.4373 43.024 29.767 42.6167 29.767Z"
      fill="#C3B8C3"
    />
    <path
      d="M42.6167 33.642H11.5476C11.15 33.642 10.8203 33.3123 10.8203 32.9148C10.8203 32.5172 11.15 32.1875 11.5476 32.1875H42.6167C43.0143 32.1875 43.344 32.5172 43.344 32.9148C43.344 33.3123 43.024 33.642 42.6167 33.642Z"
      fill="#C3B8C3"
    />
    <path
      d="M42.6167 37.517H11.5476C11.15 37.517 10.8203 37.1873 10.8203 36.7898C10.8203 36.3922 11.15 36.0625 11.5476 36.0625H42.6167C43.0143 36.0625 43.344 36.3922 43.344 36.7898C43.344 37.1873 43.024 37.517 42.6167 37.517Z"
      fill="#C3B8C3"
    />
    <path
      d="M42.6167 41.392H11.5476C11.15 41.392 10.8203 41.0623 10.8203 40.6648C10.8203 40.2672 11.15 39.9375 11.5476 39.9375H42.6167C43.0143 39.9375 43.344 40.2672 43.344 40.6648C43.344 41.0623 43.024 41.392 42.6167 41.392Z"
      fill="#C3B8C3"
    />
    <path
      d="M42.6167 45.2749H11.5476C11.15 45.2749 10.8203 44.9452 10.8203 44.5476C10.8203 44.15 11.15 43.8203 11.5476 43.8203H42.6167C43.0143 43.8203 43.344 44.15 43.344 44.5476C43.344 44.9452 43.024 45.2749 42.6167 45.2749Z"
      fill="#C3B8C3"
    />
    <path
      d="M42.6167 49.1499H11.5476C11.15 49.1499 10.8203 48.8202 10.8203 48.4226C10.8203 48.025 11.15 47.6953 11.5476 47.6953H42.6167C43.0143 47.6953 43.344 48.025 43.344 48.4226C43.344 48.8202 43.024 49.1499 42.6167 49.1499Z"
      fill="#C3B8C3"
    />
    <path
      d="M21.2833 53.0327H11.5476C11.15 53.0327 10.8203 52.703 10.8203 52.3054C10.8203 51.9078 11.15 51.5781 11.5476 51.5781H21.2833C21.6809 51.5781 22.0106 51.9078 22.0106 52.3054C22.0106 52.703 21.6906 53.0327 21.2833 53.0327Z"
      fill="#C3B8C3"
    />
    <path
      d="M21.2833 56.9077H11.5476C11.15 56.9077 10.8203 56.578 10.8203 56.1804C10.8203 55.7828 11.15 55.4531 11.5476 55.4531H21.2833C21.6809 55.4531 22.0106 55.7828 22.0106 56.1804C22.0106 56.578 21.6906 56.9077 21.2833 56.9077Z"
      fill="#C3B8C3"
    />
    <path
      d="M42.6193 53.0327H32.8835C32.4859 53.0327 32.1562 52.703 32.1562 52.3054C32.1562 51.9078 32.4859 51.5781 32.8835 51.5781H42.6193C43.0169 51.5781 43.3466 51.9078 43.3466 52.3054C43.3466 52.703 43.0266 53.0327 42.6193 53.0327Z"
      fill="#C3B8C3"
    />
    <path
      d="M42.6193 56.9077H32.8835C32.4859 56.9077 32.1562 56.578 32.1562 56.1804C32.1562 55.7828 32.4859 55.4531 32.8835 55.4531H42.6193C43.0169 55.4531 43.3466 55.7828 43.3466 56.1804C43.3466 56.578 43.0266 56.9077 42.6193 56.9077Z"
      fill="#C3B8C3"
    />
    <path
      d="M45.8588 51.077C51.541 51.077 56.1473 46.4707 56.1473 40.7885C56.1473 35.1063 51.541 30.5 45.8588 30.5C40.1766 30.5 35.5703 35.1063 35.5703 40.7885C35.5703 46.4707 40.1766 51.077 45.8588 51.077Z"
      fill="#0068FF"
    />
    <path
      d="M48.1524 42.186V35.0781H43.556V42.186H39.6094L45.8542 48.4309L52.0991 42.186H48.1524Z"
      fill="white"
    />
  </svg>
);

const JpegIcon = ({ w = "15", h = "20" }) => (
  <svg
    width={w}
    height={h}
    viewBox="0 0 15 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.60177 0H9.2936L14.9582 5.90996V17.3982C14.9582 18.8353 13.7935 20 12.3564 20H2.60177C1.16472 20 0 18.8353 0 17.3982V2.60177C0 1.16474 1.16472 0 2.60177 0Z"
      fill="#255483"
    />
    <path
      opacity="0.232"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.28125 0V5.86141H14.9539L9.28125 0Z"
      fill="white"
    />
    <path
      d="M2.65077 11.2081H3.46309V13.5652C3.46198 13.786 3.40927 13.9791 3.30495 14.1444C3.20064 14.3087 3.05637 14.4363 2.87216 14.5273C2.68905 14.6183 2.4771 14.6638 2.23628 14.6638C2.02322 14.6638 1.82957 14.6266 1.65534 14.5523C1.48222 14.4779 1.34406 14.3625 1.24086 14.206C1.13876 14.0496 1.08827 13.8493 1.08938 13.6051H1.91002C1.91335 13.6928 1.93 13.7677 1.95996 13.8298C1.99103 13.8909 2.03376 13.9369 2.08813 13.968C2.14251 13.9991 2.20743 14.0146 2.28289 14.0146C2.36168 14.0146 2.42827 13.998 2.48264 13.9647C2.53702 13.9303 2.57808 13.8798 2.60582 13.8132C2.63468 13.7466 2.64966 13.6639 2.65077 13.5652V11.2081ZM4.07411 14.6172V11.2081H5.48236C5.7376 11.2081 5.95788 11.258 6.14321 11.3579C6.32964 11.4567 6.47335 11.5948 6.57434 11.7724C6.67532 11.9488 6.72581 12.1541 6.72581 12.3883C6.72581 12.6236 6.67421 12.8294 6.57101 13.0059C6.46891 13.1812 6.32298 13.3171 6.13322 13.4137C5.94345 13.5102 5.71818 13.5585 5.45739 13.5585H4.58847V12.9093H5.30425C5.42854 12.9093 5.5323 12.8877 5.61553 12.8444C5.69987 12.8011 5.76368 12.7406 5.80696 12.663C5.85024 12.5842 5.87188 12.4926 5.87188 12.3883C5.87188 12.2829 5.85024 12.1919 5.80696 12.1153C5.76368 12.0376 5.69987 11.9777 5.61553 11.9355C5.53119 11.8934 5.42743 11.8723 5.30425 11.8723H4.89809V14.6172H4.07411ZM7.22572 14.6172V11.2081H9.60277V11.8773H8.0497V12.5764H9.48125V13.2472H8.0497V13.948H9.60277V14.6172H7.22572ZM12.4498 12.3217C12.4309 12.2518 12.4031 12.1902 12.3665 12.1369C12.3299 12.0826 12.285 12.0365 12.2317 11.9988C12.1784 11.961 12.1174 11.9328 12.0486 11.9139C11.9798 11.8939 11.9043 11.8839 11.8222 11.8839C11.6569 11.8839 11.5137 11.9239 11.3927 12.0038C11.2729 12.0837 11.1802 12.2002 11.1148 12.3533C11.0493 12.5054 11.0165 12.6901 11.0165 12.9076C11.0165 13.1263 11.0482 13.3127 11.1114 13.467C11.1747 13.6212 11.2662 13.7388 11.3861 13.8198C11.5059 13.9009 11.6513 13.9414 11.8222 13.9414C11.9731 13.9414 12.1007 13.9169 12.2051 13.8681C12.3105 13.8182 12.3904 13.7477 12.4448 13.6567C12.4991 13.5657 12.5263 13.4586 12.5263 13.3354L12.6795 13.3538H11.8505V12.7528H13.3203V13.2039C13.3203 13.5091 13.2554 13.7705 13.1256 13.988C12.9969 14.2055 12.8193 14.3725 12.5929 14.489C12.3676 14.6055 12.1085 14.6638 11.8155 14.6638C11.4904 14.6638 11.2046 14.5933 10.9583 14.4524C10.7119 14.3115 10.5199 14.1106 10.3823 13.8498C10.2447 13.5879 10.1759 13.2772 10.1759 12.9176C10.1759 12.638 10.2175 12.39 10.3008 12.1736C10.384 11.9561 10.5 11.7718 10.6487 11.6209C10.7985 11.47 10.9716 11.3557 11.168 11.278C11.3656 11.2003 11.5781 11.1615 11.8056 11.1615C12.0031 11.1615 12.1868 11.1898 12.3565 11.2464C12.5274 11.303 12.6784 11.3829 12.8093 11.4861C12.9414 11.5893 13.0485 11.7119 13.1306 11.854C13.2127 11.996 13.2637 12.1519 13.2837 12.3217H12.4498Z"
      fill="white"
    />
  </svg>
);

const PdfIcon = ({ w = "15", h = "20" }) => (
  <svg
    width={w}
    height={h}
    viewBox="0 0 15 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.60369 0H9.29034L14.9575 5.90705V17.3963C14.9575 18.8356 13.7931 20 12.3588 20H2.60369C1.16441 20 4.11296e-10 18.8356 4.11296e-10 17.3963V2.60369C-2.52695e-05 1.16441 1.16439 0 2.60369 0Z"
      fill="#E5252A"
    />
    <path
      opacity="0.302"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.28125 0V5.86207H14.9534L9.28125 0Z"
      fill="white"
    />
    <path
      d="M2.89062 14.9188V11.2656H4.44485C4.82966 11.2656 5.13452 11.3706 5.3644 11.5855C5.59428 11.7954 5.70923 12.0802 5.70923 12.435C5.70923 12.7899 5.59428 13.0747 5.3644 13.2846C5.13452 13.4995 4.82966 13.6045 4.44485 13.6045H3.82516V14.9188H2.89062ZM3.82516 12.8099H4.33991C4.47983 12.8099 4.58978 12.7799 4.66475 12.7099C4.7397 12.645 4.77971 12.555 4.77971 12.4351C4.77971 12.3151 4.73973 12.2252 4.66475 12.1602C4.5898 12.0902 4.47985 12.0603 4.33991 12.0603H3.82516V12.8099ZM6.09402 14.9188V11.2656H7.38837C7.64324 11.2656 7.88313 11.3006 8.10801 11.3756C8.33289 11.4505 8.5378 11.5555 8.7177 11.7004C8.89762 11.8403 9.04254 12.0302 9.14749 12.2701C9.24743 12.51 9.30242 12.7849 9.30242 13.0947C9.30242 13.3996 9.24746 13.6744 9.14749 13.9143C9.04254 14.1542 8.89762 14.3441 8.7177 14.484C8.53778 14.6289 8.33289 14.7339 8.10801 14.8089C7.88313 14.8838 7.64324 14.9188 7.38837 14.9188H6.09402ZM7.00856 14.1242H7.27842C7.42335 14.1242 7.55829 14.1092 7.68322 14.0742C7.80315 14.0393 7.91811 13.9843 8.02806 13.9093C8.133 13.8344 8.21796 13.7294 8.27792 13.5895C8.33789 13.4496 8.36789 13.2846 8.36789 13.0947C8.36789 12.8998 8.33789 12.7349 8.27792 12.595C8.21796 12.4551 8.133 12.3501 8.02806 12.2751C7.91811 12.2002 7.80318 12.1452 7.68322 12.1102C7.55829 12.0752 7.42335 12.0602 7.27842 12.0602H7.00856V14.1242ZM9.77219 14.9188V11.2656H12.3709V12.0602H10.7067V12.6449H12.036V13.4345H10.7067V14.9188H9.77219Z"
      fill="white"
    />
  </svg>
);

const PptIcon = ({ w = "15", h = "20" }) => (
  <svg
    width={w}
    height={h}
    viewBox="0 0 15 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.60177 0H9.2936L14.9582 5.90996V17.3982C14.9582 18.8353 13.7935 20 12.3564 20H2.60177C1.16472 20 0 18.8353 0 17.3982V2.60177C0 1.16474 1.16472 0 2.60177 0Z"
      fill="#FF6600"
    />
    <path
      opacity="0.302"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.28125 0V5.86141H14.9539L9.28125 0Z"
      fill="white"
    />
    <path
      d="M3.47676 14.7812V11.3722H4.88501C5.14025 11.3722 5.36053 11.4221 5.54585 11.522C5.73229 11.6207 5.876 11.7589 5.97698 11.9365C6.07797 12.1129 6.12846 12.3182 6.12846 12.5524C6.12846 12.7876 6.07686 12.9935 5.97365 13.1699C5.87156 13.3453 5.72563 13.4812 5.53587 13.5777C5.3461 13.6743 5.12083 13.7226 4.86004 13.7226H3.99112V13.0734H4.7069C4.83119 13.0734 4.93495 13.0517 5.01818 13.0085C5.10252 12.9652 5.16633 12.9047 5.20961 12.827C5.25289 12.7482 5.27452 12.6567 5.27452 12.5524C5.27452 12.4469 5.25289 12.3559 5.20961 12.2794C5.16633 12.2017 5.10252 12.1418 5.01818 12.0996C4.93384 12.0574 4.83008 12.0363 4.7069 12.0363H4.30074V14.7812H3.47676ZM6.62837 14.7812V11.3722H8.03662C8.29186 11.3722 8.51214 11.4221 8.69746 11.522C8.8839 11.6207 9.02761 11.7589 9.1286 11.9365C9.22958 12.1129 9.28007 12.3182 9.28007 12.5524C9.28007 12.7876 9.22847 12.9935 9.12527 13.1699C9.02317 13.3453 8.87724 13.4812 8.68748 13.5777C8.49771 13.6743 8.27244 13.7226 8.01165 13.7226H7.14273V13.0734H7.85851C7.9828 13.0734 8.08656 13.0517 8.16979 13.0085C8.25413 12.9652 8.31794 12.9047 8.36122 12.827C8.4045 12.7482 8.42614 12.6567 8.42614 12.5524C8.42614 12.4469 8.4045 12.3559 8.36122 12.2794C8.31794 12.2017 8.25413 12.1418 8.16979 12.0996C8.08545 12.0574 7.98169 12.0363 7.85851 12.0363H7.45235V14.7812H6.62837ZM9.66846 12.0413V11.3722H12.5499V12.0413H11.5162V14.7812H10.7038V12.0413H9.66846Z"
      fill="white"
    />
  </svg>
);

const PptxIcon = ({ w = "15", h = "20" }) => (
  <svg
    width={w}
    height={h}
    viewBox="0 0 15 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.60177 0H9.2936L14.9582 5.90996V17.3982C14.9582 18.8353 13.7935 20 12.3564 20H2.60177C1.16472 20 0 18.8353 0 17.3982V2.60177C0 1.16474 1.16472 0 2.60177 0Z"
      fill="#954109"
    />
    <path
      opacity="0.302"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.28906 0V5.86141H14.9618L9.28906 0Z"
      fill="white"
    />
    <path
      d="M2.26189 14.1758V11.3349H3.43542C3.64812 11.3349 3.83169 11.3765 3.98613 11.4597C4.14149 11.542 4.26125 11.6572 4.3454 11.8051C4.42956 11.9522 4.47164 12.1232 4.47164 12.3184C4.47164 12.5144 4.42863 12.686 4.34263 12.833C4.25755 12.9791 4.13594 13.0924 3.97781 13.1729C3.81967 13.2533 3.63194 13.2935 3.41462 13.2935H2.69052V12.7526H3.287C3.39057 12.7526 3.47704 12.7345 3.5464 12.6985C3.61668 12.6624 3.66986 12.612 3.70592 12.5473C3.74199 12.4816 3.76002 12.4053 3.76002 12.3184C3.76002 12.2305 3.74199 12.1547 3.70592 12.0909C3.66986 12.0261 3.61668 11.9762 3.5464 11.9411C3.47611 11.9059 3.38965 11.8884 3.287 11.8884H2.94853V14.1758H2.26189ZM4.88823 14.1758V11.3349H6.06177C6.27447 11.3349 6.45803 11.3765 6.61247 11.4597C6.76783 11.542 6.88759 11.6572 6.97175 11.8051C7.0559 11.9522 7.09798 12.1232 7.09798 12.3184C7.09798 12.5144 7.05498 12.686 6.96897 12.833C6.88389 12.9791 6.76228 13.0924 6.60415 13.1729C6.44601 13.2533 6.25828 13.2935 6.04096 13.2935H5.31686V12.7526H5.91334C6.01692 12.7526 6.10338 12.7345 6.17274 12.6985C6.24302 12.6624 6.2962 12.612 6.33226 12.5473C6.36833 12.4816 6.38636 12.4053 6.38636 12.3184C6.38636 12.2305 6.36833 12.1547 6.33226 12.0909C6.2962 12.0261 6.24302 11.9762 6.17274 11.9411C6.10246 11.9059 6.01599 11.8884 5.91334 11.8884H5.57487V14.1758H4.88823ZM7.42163 11.8925V11.3349H9.82281V11.8925H8.96138V14.1758H8.28445V11.8925H7.42163ZM10.9312 11.3349L11.45 12.2324H11.4722L11.9966 11.3349H12.7651L11.9078 12.7553L12.7928 14.1758H12.0049L11.4722 13.2686H11.45L10.9174 14.1758H10.135L11.0159 12.7553L10.1572 11.3349H10.9312Z"
      fill="white"
    />
  </svg>
);

const ZipIcon = ({ w = "15", h = "20" }) => (
  <svg
    width={w}
    height={h}
    viewBox="0 0 15 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.60177 0H9.2936L14.9582 5.90996V17.3982C14.9582 18.8353 13.7935 20 12.3564 20H2.60177C1.16472 20 0 18.8353 0 17.3982V2.60177C0 1.16474 1.16472 0 2.60177 0Z"
      fill="#E9CD4D"
    />
    <path
      opacity="0.232"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.28125 0V5.86141H14.9539L9.28125 0Z"
      fill="white"
    />
    <path
      d="M3.75417 14.6172V14.1478L5.41044 11.8773H3.75584V11.2081H6.45248V11.6775L4.79621 13.948H6.45082V14.6172H3.75417ZM7.87416 11.2081V14.6172H7.05019V11.2081H7.87416ZM8.48519 14.6172V11.2081H9.89343C10.1487 11.2081 10.369 11.258 10.5543 11.3579C10.7407 11.4567 10.8844 11.5948 10.9854 11.7724C11.0864 11.9488 11.1369 12.1541 11.1369 12.3883C11.1369 12.6236 11.0853 12.8294 10.9821 13.0059C10.88 13.1812 10.7341 13.3171 10.5443 13.4137C10.3545 13.5102 10.1293 13.5585 9.86846 13.5585H8.99955V12.9093H9.71532C9.83961 12.9093 9.94337 12.8877 10.0266 12.8444C10.1109 12.8011 10.1747 12.7406 10.218 12.663C10.2613 12.5842 10.2829 12.4926 10.2829 12.3883C10.2829 12.2829 10.2613 12.1919 10.218 12.1153C10.1747 12.0376 10.1109 11.9777 10.0266 11.9355C9.94226 11.8934 9.8385 11.8723 9.71532 11.8723H9.30916V14.6172H8.48519Z"
      fill="white"
    />
  </svg>
);

const JpgIcon = ({ w = "15", h = "20" }) => (
  <svg
    width={w}
    height={h}
    viewBox="0 0 15 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.60177 0H9.2936L14.9582 5.90996V17.3982C14.9582 18.8353 13.7935 20 12.3564 20H2.60177C1.16472 20 0 18.8353 0 17.3982V2.60177C0 1.16474 1.16472 0 2.60177 0Z"
      fill="#9747FF"
    />
    <path
      opacity="0.232"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.28906 0V5.86141H14.9618L9.28906 0Z"
      fill="white"
    />
    <path
      d="M4.41566 10.8008H5.29898V13.3221C5.29898 13.5565 5.24492 13.7644 5.13676 13.9483C5.02738 14.1309 4.87598 14.274 4.68246 14.3749C4.48777 14.4759 4.27145 14.5264 4.0323 14.5264C3.63211 14.5264 3.32086 14.4254 3.09852 14.2235C2.87617 14.0216 2.76562 13.7356 2.76562 13.3654H3.65375C3.65375 13.5337 3.68258 13.6551 3.74027 13.7308C3.79918 13.8065 3.89531 13.845 4.0323 13.845C4.15488 13.845 4.24984 13.7993 4.31594 13.7068C4.38203 13.6154 4.4157 13.4868 4.4157 13.3222V10.8008H4.41566Z"
      fill="white"
    />
    <path
      d="M6.74508 13.2284V14.4759H5.85938V10.8008H7.32555C7.60676 10.8008 7.85555 10.8525 8.07188 10.9558C8.2882 11.0592 8.45523 11.207 8.57422 11.3981C8.69199 11.5892 8.75207 11.8055 8.75207 12.0482C8.75207 12.4064 8.62348 12.6924 8.36629 12.9075C8.11031 13.1214 7.75816 13.2284 7.30992 13.2284L6.74508 13.2284ZM6.74508 12.5446H7.32555C7.49742 12.5446 7.6284 12.5025 7.71852 12.416C7.80863 12.3307 7.85312 12.2093 7.85312 12.053C7.85312 11.8812 7.80625 11.7442 7.71371 11.6408C7.62117 11.5387 7.495 11.487 7.33516 11.4846H6.74508V12.5446Z"
      fill="white"
    />
    <path
      d="M12.2275 14.0198C12.0916 14.1712 11.8921 14.2926 11.629 14.3851C11.367 14.4777 11.0798 14.5245 10.7661 14.5245C10.2854 14.5245 9.90082 14.3767 9.61356 14.0823C9.32512 13.7878 9.17129 13.378 9.15086 12.854L9.14844 12.5355C9.14844 12.1738 9.21215 11.8577 9.34074 11.5873C9.46813 11.3181 9.65082 11.1102 9.88996 10.9648C10.1279 10.8194 10.4031 10.7461 10.7156 10.7461C11.1735 10.7461 11.5292 10.8507 11.7828 11.061C12.0352 11.2701 12.183 11.5825 12.225 11.9984H11.3718C11.3417 11.7929 11.2756 11.6462 11.1746 11.5585C11.0737 11.4708 10.9307 11.4275 10.7456 11.4275C10.5245 11.4275 10.3527 11.5213 10.2313 11.71C10.1098 11.8986 10.0486 12.1679 10.0474 12.5176V12.7399C10.0474 13.1065 10.1099 13.3829 10.2348 13.5668C10.361 13.7506 10.5581 13.8432 10.8273 13.8432C11.0569 13.8432 11.2288 13.7915 11.3417 13.6893V13.1185H10.7264V12.5104H12.2275V14.0198Z"
      fill="white"
    />
  </svg>
);

const TxtIcon = ({ w = "15", h = "20" }) => (
  <svg
    width={w}
    height={h}
    viewBox="0 0 15 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.60177 0H9.2936L14.9582 5.90996V17.3982C14.9582 18.8353 13.7935 20 12.3564 20H2.60177C1.16472 20 0 18.8353 0 17.3982V2.60177C0 1.16474 1.16472 0 2.60177 0Z"
      fill="#67D6CE"
    />
    <path
      opacity="0.302"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.28125 0V5.86141H14.9539L9.28125 0Z"
      fill="#7D8175"
    />
    <path
      d="M2.61523 11.8773V11.2081H5.49665V11.8773H4.46294V14.6172H3.65061V11.8773H2.61523ZM6.82678 11.2081L7.44934 12.2851H7.47597L8.10519 11.2081H9.02737L7.99865 12.9126L9.06066 14.6172H8.11517L7.47597 13.5285H7.44934L6.81013 14.6172H5.8713L6.92832 12.9126L5.89793 11.2081H6.82678ZM9.43573 11.8773V11.2081H12.3171V11.8773H11.2834V14.6172H10.4711V11.8773H9.43573Z"
      fill="white"
    />
  </svg>
);
const FolderIcon = ({ w = "18", h = "14" }) => (
  <svg
    width={w}
    height={h}
    viewBox="0 0 18 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.0525 13.6364C1.49144 13.6364 1.00909 13.4345 0.605455 13.0309C0.201818 12.6273 0 12.1449 0 11.5839V2.0525C0 1.48083 0.201818 0.995833 0.605455 0.5975C1.00909 0.199166 1.49144 0 2.0525 0H5.17364C5.45 0 5.71523 0.0507578 5.96932 0.152273C6.22341 0.25394 6.45333 0.408334 6.65909 0.615455L8.81636 2.77273H15.9475C16.5192 2.77273 17.0042 2.97189 17.4025 3.37023C17.8008 3.76856 18 4.25356 18 4.82523V11.5839C18 12.1449 17.8008 12.6273 17.4025 13.0309C17.0042 13.4345 16.5192 13.6364 15.9475 13.6364H2.0525Z"
      fill="#666666"
    />
  </svg>
);

export const fileIcons = {
  xlsx: XlsxIcon,
  txt: TxtIcon,
  folder: FolderIcon,
  jpg: JpgIcon,
  zip: ZipIcon,
  pptx: PptxIcon,
  ppt: PptIcon,
  pdf: PdfIcon,
  jpeg: JpegIcon,
  doc: DocIcon,
  docx: DocIcon,
  xls: XlsxIcon,
  png: PngIcon,
  // cross: CrossIcon
};
